export default {
  domainDirectory: {
    title: "โดเมนทางการ", subtitle: "ตรวจสอบที่อยู่ทางการที่นี่ แตะเพื่อคัดลอก", available: " รายการที่เชื่อมต่อได้",
    loading: "กำลังโหลดโดเมน…", loadFailed: "โหลดโดเมนไม่สำเร็จ", retry: "โหลดใหม่", empty: "ไม่มีโดเมนที่เปิดใช้งาน",
    tapToCopy: "แตะเพื่อคัดลอก", checking: "กำลังตรวจสอบ", checkingShort: "กำลังตรวจ", online: "เชื่อมต่อได้", offline: "หมดเวลาเชื่อมต่อ",
    waiting: "รอการตรวจสอบ", timeout: "หมดเวลา", testAll: "ทดสอบทุกโดเมนตอนนี้", updatedEveryFifteenSeconds: "ระบบทดสอบการเชื่อมต่ออัตโนมัติทุก 15 วินาที",
    saveReminder: "ถ่ายภาพหน้าจอหน้านี้เพื่อเก็บข้อมูลโดเมนไว้", copied: "คัดลอกโดเมนแล้ว",
    names: { primary: "โดเมนหลัก", chinaAccel: "เร่งความเร็วจีน", secondary: "โดเมนรอง" },
  },
  nickname: {"edit": "แก้ไขชื่อเล่น", "hint": "2–20 ตัวอักษรจีน/อังกฤษ ตัวเลข หรือ _", "saved": "บันทึกชื่อเล่นแล้ว", "taken": "ชื่อเล่นนี้ถูกใช้แล้ว", "invalid": "ใช้ 2–20 ตัวอักษรจีน/อังกฤษ ตัวเลข หรือ _ ห้ามใช้ชื่อที่สงวนไว้", "failed": "บันทึกไม่สำเร็จ กรุณาลองใหม่"},
  common: {
    confirm: "ยืนยัน",
    cancel: "ยกเลิก",
    search: "ค้นหา",
    language: "ภาษา",
    switched: "เปลี่ยนแล้ว",
    currentLanguage: "ภาษาปัจจุบัน",
    selectLanguage: "เลือกภาษา",
    loading: "กำลังโหลด...",
    loadingMore: "กำลังโหลดเพิ่มเติม...",
    noMoreData: "ไม่มีข้อมูลเพิ่มเติม",
    noData: "ไม่มีข้อมูล",
    serverUnavailable: "เซิร์ฟเวอร์ไม่พร้อมใช้งานชั่วคราว",
    loadFailed: "โหลดล้มเหลว",
    requestFailed: "คำขอล้มเหลว",
    projectName: "PANTA MARKET",
    duplicateSubmission: "กรุณาอย่าส่งซ้ำ",
    fee: "ค่าธรรมเนียม",
    tip: "แจ้งเตือน",
    connecting: "กำลังเชื่อมต่อ...",
    connectWalletFirst: "กรุณาเชื่อมต่อกระเป๋าก่อน",
    connect: "เชื่อมต่อ",
    insufficientBalance: "ยอดคงเหลือไม่เพียงพอ",
    developing: "ฟีเจอร์กำลังพัฒนา",
    copyFailed: "คัดลอกล้มเหลว",
    sessionAuthRelogin: "เข้าสู่ระบบอีกครั้ง",
    sessionAuthStay: "อยู่ต่อ",
    pleaseRelogin: "เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
    retry: "แตะเพื่อลองใหม่",
    submit: "ส่ง",
    pager: {
      prevPage: "ก่อนหน้า",
      nextPage: "ถัดไป",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "ไปที่",
      jumpConfirm: "ไป",
    },
  },
  tabbar: {
    home: "หน้าแรก",
    market: "ไทม์ไลน์",
    timeline: "ไทม์ไลน์",
    prediction: "ทำนายสัญญาเหตุการณ์ AI",
    createMarket: "สร้างตลาด",
    planet: "ดาวเคราะห์",
    trade: "การค้า",
    finance: "การเงิน",
    fund: "กองทุน",
    assets: "สินทรัพย์",
    planethistory: "ประวัติ"
  },
  tradeMenu: {
    contract: "สัญญาเหตุการณ์",
    insurance: "ประกัน",
    spot: "สปอต",
    flash: "แลกเปลี่ยนด่วน"
  },
  home: {
    searchPlaceholder: "BTC",
    bannerTitle: "PANTA MARKET",
    bannerSubtitle: "AI ทำนาย · สัญญาเหตุการณ์ · วิเคราะห์อัจฉริยะ",
    predictionCategories: {
      hot: "ไทม์ไลน์",
      sports: "กีฬา",
      world: "โลก",
      politics: "การเมือง",
      economy: "เศรษฐกิจ"
    },
    predictionSubCategories: {
      crypto: "สปอต",
      forex: "ฟอเร็กซ์",
      commodities: "สินค้าโภคภัณฑ์"
    },
    features: {
      recharge: "เติมเงิน",
      rechargeDesc: "ฝากเงินอย่างรวดเร็ว",
      contract: "สัญญาเหตุการณ์",
      contractDesc: "เครื่องมือทางการเงินที่เป็นนวัตกรรม",
      predict: "การคาดการณ์ AI",
      fund: "PANTA MARKET Treasury",
      invite: "เชิญเพื่อน",
      global: "โหนดทั่วโลก"
    },
    insurance: {
      title: "กองทุนประกันสัญญา (TAKER)",
      aiPoolTitle: "กองทุนประกัน AI",
      ordinaryPoolTitle: "กองทุนมูลค่าประกันทั่วไป",
      approxUsdt: "≈ {amount} U",
      approxPantaRef: "≈ {amount} PANTA (อ้างอิง)",
      more: "เรียนรู้เพิ่มเติม",
      yesterday: "เพิ่มเมื่อวาน",
      service: "บริการอัจฉริยะ"
    },
    market: {
      tabs: {
        main: "หลัก",
        hot: "ยอดนิยม",
        rise: "อันดับการขึ้น",
        price: "ราคา"
      },
      headers: {
        pair: "คู่",
        latest: "ราคาล่าสุด",
        change: "การเปลี่ยนแปลง 24 ชั่วโมง"
      },
      viewMore: "ดูเพิ่มเติม",
      collapse: "ย่อ"
    },
    announcement: {
      title: "ประกาศ",
      heading: "ประกาศ",
      text: "ยินดีต้อนรับสู่ PANTA MARKET ที่นี่คุณจะได้สัมผัสกับระบบ AI และการประกันการคาดการณ์ที่เป็นเอกลักษณ์ซึ่งสร้างโดย PANTA MARKET ช่วยให้คุณเข้าร่วมตลาดการคาดการณ์ WEB3 ได้อย่างง่ายดายและเริ่มต้นการเดินทางสู่ความมั่งคั่งของคุณ",
      time: "2025/11/19 10:00",
      gotIt: "เข้าใจแล้ว",
      viewDetail: "ดูรายละเอียด",
      systemLabel: "ประกาศระบบ"
    },
    timePeriods: {
      "1min": "1 นาที",
      "30min": "30 นาที",
      "1hour": "1 ชั่วโมง"
    },
    footer: {
      australia: "· ออสเตรเลีย",
      uae: "· สหรัฐอาหรับเอมิเรตส์",
      attention: "· ข้อควรระวัง:",
      attentionText: "PANTA MARKET เป็นบริษัทตลาดการคาดการณ์ WEB3 ที่ใช้ AI และดำเนินการด้วยตนเอง เราไม่อนุญาตให้บุคคลที่สามเรียกเก็บค่าธรรมเนียมในรูปแบบหรือชื่อใด ๆ หากมีข้อสงสัยโปรดติดต่อฝ่ายบริการลูกค้าอย่างเป็นทางการที่: {email}"
    },
    timeframes: {
      "1s": "1 นาที",
      "1m": "1 นาที",
      "5m": "5 นาที",
      "15m": "15 นาที",
      "1h": "1 ชั่วโมง",
      "4h": "4 ชั่วโมง",
      "1d": "1 วัน"
    },
    statusHotEn: "HOT",
    yes: "ใช่",
    no: "ไม่",
    hotBannerTitle: "สัญญาเหตุการณ์",
    homeBanner: {
      s1t1: "ขับเคลื่อนด้วย AI",
      s1t2: "ระบบนิเวศหลัก AstralX",
      s1cta: "AstralX",
      s2t: "กองทุน Galaxy",
      s2s1: "เรียนรู้การคุ้มครองเงินต้น",
      s2s2: "และกฎการจ่ายผลตอบแทน",
      s2cta: "สมัคร",
      s3s: "ทำนายราคา",
      s3cta: "ทำนาย",
    },
    catCrypto: "คริปโต",
    catMetal: "โลหะ",
    catSports: "กีฬา",
    catPolitics: "การเมือง",
    catEntertainment: "บันเทิง",
    statusHot: "มาแรง",
    statusLocked: "ล็อก",
    statusLive: "กำลังดำเนิน",
    statusLockedWait: "ล็อก รอชำระ",
    jouleUnit: "JOULE",
    nowLabel: "ตอนนี้",
    endAtFallback: "--",
    predictionLabel: "Prediction",
    rise: "Up",
    fall: "Down",
    viewMoreOptions: "ดูอีก {n} ตัวเลือก",
    categoryAll: "ทั้งหมด",
    categoryCrypto: "คริปโต",
    categoryEquity: "หุ้น",
    categoryCommodity: "สินค้าโภคภัณฑ์",
    categoryForex: "ฟอเร็กซ์",
    categoryMetal: "โลหะ"
  },
  withdraw: {
    title: "ถอน",
    headerTitle: "ถอน",
    address: "ที่อยู่การถอน",
    addressLabel: "ที่อยู่การถอน",
    addressPlaceholder: "ป้อนหรือวางที่อยู่",
    network: "เครือข่าย",
    selectNetwork: "เลือกเครือข่าย",
    networkHint: "โปรดตรวจสอบให้แน่ใจว่าที่อยู่การถอนตรงกับเครือข่ายที่เลือก",
    withdrawAmount: "จำนวนที่ถอน",
    receiveAmount: "จำนวนที่จะได้รับ",
    networkFee: "ค่าธรรมเนียมเครือข่าย",
    submit: "ยืนยันการถอน",
    submitButton: "ถอน",
    balance: "ยอดคงเหลือ:",
    all: "ทั้งหมด",
    amountPlaceholder: "โปรดป้อน",
    minimumWithdrawal: "จำนวนถอนขั้นต่ำ: {amount} USDT",
    fee: "ค่าธรรมเนียม",
    confirm: "ยืนยัน",
    confirmTitle: "ยืนยันการกระทำ",
    confirmContent: "คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ",
    toasts: {
      fetchFailed: "ไม่สามารถดึงข้อมูลสินทรัพย์ได้",
      enterAddress: "โปรดป้อนที่อยู่การถอน",
      enterValidAmount: "โปรดป้อนจำนวนถอนที่ถูกต้อง",
      insufficientBalance: "ยอดเงินไม่เพียงพอ",
      minimumAmount: "จำนวนถอนขั้นต่ำคือ {amount} USDT",
      processing: "กำลังประมวลผล...",
      success: "ถอนสำเร็จ!",
      requestSuccess: "ส่งคำขอถอนสำเร็จ",
      requestFailed: "การถอนล้มเหลว โปรดลองอีกครั้ง",
      notConfigured: "Withdrawals are not available yet"
    },
    addressHint: "Withdrawal will be sent to your wallet address"
  },
  deposit: {
    headerTitle: "ฝาก",
    connectPrompt: "โปรดเชื่อมต่อกระเป๋าเงินของคุณเพื่อฝากเงิน",
    loading: "กำลังโหลด...",
    depositAddress: "ที่อยู่การฝาก",
    minimumDeposit: "*ฝากขั้นต่ำ 10.0000 USDT",
    depositAmount: "จำนวนเงินฝาก",
    balance: "ยอดคงเหลือ",
    amaBalance: "ยอดคงเหลือ TAKER",
    amount: "จำนวนเงิน",
    amountPlaceholder: "ป้อนจำนวนเงินฝาก",
    minimumNotice: "*ขั้นต่ำ {min} {token}",
    processing: "กำลังประมวลผล...",
    confirm: "ยืนยันการฝาก",
    confirmTitle: "ยืนยันการกระทำ",
    confirmContent: "คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ",
    helpText: "การฝากจะเรียกใช้เมธอด recharge ของสัญญาอัจฉริยะ ต้องอนุมัติโทเค็น TAKER ก่อน",
    toasts: {
      copySuccess: "คัดลอกสำเร็จ",
      dataLoadFailed: "ไม่สามารถโหลดข้อมูลได้",
      enterValidAmount: "โปรดป้อนจำนวนเงินฝากที่ถูกต้อง",
      invalidAmount: "จำนวนเงินฝากต้องไม่น้อยกว่า {min} TAKER",
      invalidAddress: "ที่อยู่การฝากไม่ถูกต้อง",
      checkingAllowance: "กำลังตรวจสอบวงเงิน...",
      approving: "กำลังอนุมัติ...",
      approveSuccess: "อนุมัติสำเร็จ",
      depositing: "กำลังฝาก...",
      depositSuccess: "ฝากสำเร็จ",
      depositFailed: "ฝากล้มเหลว",
      balanceLoadFailed: "อ่านยอด USDT ทดสอบไม่ได้ กรุณารีเฟรชแล้วลองใหม่",
      contractError: "การเรียกสัญญาล้มเหลว โปรดตรวจสอบยอดคงเหลือ",
      userCancelled: "คุณได้ยกเลิกการดำเนินการ",
      insufficientFunds: "ยอดคงเหลือไม่เพียงพอ",
      wrongNetwork: "โปรดเปลี่ยนไปยังเครือข่ายที่ถูกต้อง",
      requestingAuth: "กำลังขอการอนุมัติจากกระเป๋าเงิน...",
      waitingConfirmation: "กำลังรอการยืนยันธุรกรรม...",
      transactionFailed: "การทำธุรกรรมล้มเหลว",
      transactionCancelled: "คุณได้ยกเลิกธุรกรรม",
      genericError: "ธุรกรรมล้มเหลว",
      configNotReady: "Deposits are not available yet",
      invalidTxHash: "Please enter a valid transaction hash",
      claimPending: "Deposit submitted, credit pending",
      cannotGetBalance: "Cannot get balance, please refresh and try again"
    },
    depositNotice: "Please transfer to the following address, the system will process automatically after arrival",
    usdtBalance: "USDT Balance"
  },
  team: {
    headerTitle: "ทีมของฉัน",
    contractEarnings: "รายได้จากสัญญาของฉัน",
    btcFund: "ผลตอบแทนการเงิน",
    stats: {
      teamSubscribed: "สเตคทีม",
      personalSubscribed: "สเตคส่วนตัว",
      totalTeam: "วอลุ่มทีม",
      periodTeam: "รายได้ทีม",
      periodPersonal: "วอลุ่มส่วนตัว",
      personalEarnings: "รายได้สะสมส่วนตัว",
      teamEarnings: "รายได้ทีม",
      personalVolume: "วอลุ่มส่วนตัว",
      teamVolume: "วอลุ่มทีม",
      personalPower: "พลังส่วนตัว",
      teamTotalPower: "พลังรวมของทีม"
    },
    links: {
      invite: "เชิญเพื่อน",
      details: "รายละเอียดทีม"
    },
    inviteBannerTitle: "เชิญเพื่อนเพื่อปลดล็อกค่าคอมมิชชั่นทีม",
    inviteBannerSubtitle: "ปลดล็อกค่าคอมมิชชั่นทีมของคุณ",
    inviteBannerCta: "เข้าร่วมเลย",
    unclassifiedHint: "แหล่งจ่ายย้อนหลังรอตรวจ: {amount} {asset}"
  },
  my: {
    headerTitle: "ของฉัน",
    login: "แตะเพื่อเข้าสู่ระบบ",
    inviteCode: "รหัสเชิญ:",
    groups: {
      common: "ฟังก์ชันทั่วไป",
      trading: "การซื้อขาย",
      finance: "การเงิน",
      help: "ช่วยเหลือ"
    },
    features: {
      invite: "เชิญเพื่อน",
      team: "ทีมของฉัน",
      insurance: "ประกันสัญญาเหตุการณ์",
      contract: "สัญญาเหตุการณ์",
      exchange: "แลกเปลี่ยน",
      fund: "กองทุนคลัง AI",
      communitySquare: "จัตุรัสชุมชน",
      createEvent: "สร้างอีเวนต์",
      community: "ชุมชนอย่างเป็นทางการ",
      terms: "ข้อกำหนดในการให้บริการ",
      announcement: "ประกาศ",
      privacy: "นโยบายความเป็นส่วนตัว",
      aboutUs: "เกี่ยวกับเรา"
    }
  },
  finance: {
    title: "หน้าการเงินกำลังอยู่ในระหว่างการพัฒนา..."
  },
  wealthAccess: {
    exchangeThresholdFailed: "แลกเปลี่ยนไม่สำเร็จ: ไม่ผ่านเงื่อนไข",
    internalPrice: "ราคาภายใน",
    marketPrice: "ราคาตลาด",
    coinBasis: "สัญญาฐานเหรียญ",
    legacyBasis: "สัญญาฐานเหรียญ",
    contractBasis: "ฐานการชำระ",
    unitPrice: "ราคาซื้อต่อหน่วย",
    quotaUsed: "ยอดซื้อราคาภายในสะสม",
    quotaRemaining: "โควตาราคาภายในคงเหลือ",
    quotaHint: "จำกัดตลอดชีพ {limit} PANTA รวมทุกแผน การปิดราคา ครบกำหนด หรือเปลี่ยน VIP ไม่รีเซ็ตยอดสะสม",
    principal: "เงินต้น",
    principalReturn: "เงินต้นคืนเมื่อครบกำหนด",
    dailyYield: "ผลตอบแทนรวมต่อวัน",
    coinYieldHint: "ผลตอบแทนต่อวัน = เงินต้น PANTA × อัตราต่อปี ÷ 360 ปัดลงเป็นหน่วยย่อย ราคาที่เปลี่ยนไม่กระทบจำนวนเหรียญตามสัญญา การแบ่งจ่ายตามกฎที่ใช้",
    legacyHint: "สัญญาฐานเหรียญ การคืนเงินต้น PANTA คำนวณจากราคาครบกำหนดตามสัญญา",
    quotaError: "เกินโควตาราคาภายใน กรุณาลดจำนวน ระบบไม่แบ่งคำสั่งหรือเปลี่ยนเป็นราคาตลาดอัตโนมัติ",
    permissionChanged: "แผนนี้ไม่รองรับ VIP ปัจจุบันของคุณ อัปเดตรายการแล้ว",
    quoteChanged: "ราคาหรือสิทธิ์เปลี่ยนแล้ว ตรวจสอบราคาใหม่และยืนยันอีกครั้ง",
    quoteExpired: "ราคาหมดอายุ กรุณาอัปเดตและตรวจสอบก่อนยืนยัน",
    retryQuote: "อัปเดตราคา",
    stakeGateTitle: "เงื่อนไขสเตกสำหรับขาย PANTA",
    stakeGateBody: "VIP{vip}: สเตกที่ใช้ได้ {staked} PANTA; ต้องมี {required} PANTA; ขาด {shortfall} PANTA จำกัดเฉพาะการขาย ไม่กระทบการซื้อ",
    goStake: "ไปสเตก",
    refreshEligibility: "อัปเดตสิทธิ์",
  },
  fundPage: {
    heroTitle: "แจกผลตอบแทน PANTA ทุกวัน",
    heroDesc: "สมัครกองทุน Galaxy เพื่อรับเงินปันผลรายปี",
    learnMore: "ดูเพิ่มเติม",
    allProducts: "สินค้าทั้งหมด",
    subscribe: "สมัคร",
    stake: "สเตก",
    stakePreview: "ดูตัวอย่างการสเตก",
    searchCoin: "ค้นหาเหรียญ",
    allPeriods: "ทุกช่วงเวลา",
    colCoin: "ชื่อกองทุน",
    colApy: "APY ตามเหรียญ",
    colTerm: "ระยะเวลา",
    fixedTerm: "ประจำ",
    galaxyProduct: "Galaxy {n}",
    termLabel: "ระยะเวลา",
    apyLabel: "APY",
    stakeCap: "การถือครองส่วนบุคคล",
    stakeAmount: "จำนวนที่สเตก",
    estEarnings: "ผลตอบแทนโดยประมาณ",
    stakeDisclaimer: "ผลตอบแทนเป็นเพียงตัวอย่าง ไม่รับประกัน ประมาณ 70% เข้ายอดใช้ได้ และ 30% เป็นเงินทดลอง เงินทดลองปลดล็อกหลังทำเทิร์นโอเวอร์ราว 3 เท่า",
    stakeSuccess: "สเตกสำเร็จ",
    annualized: "APY โดยประมาณ",
    perShareYield: "ผลตอบแทนต่อ 10,000 (WBS)",
    dayUnit: "วัน",
    empty: "ยังไม่มีสินค้ากองทุน",
    loadFailed: "โหลดไม่สำเร็จ",
    rulesTitle: "ข้อมูลกองทุน",
    gotIt: "เข้าใจแล้ว",
    pantaAvailable: "PANTA ที่ใช้ได้",
    activeFaceValue: "หน่วยที่ลงทุนอยู่",
    totalReward: "ผลตอบแทนกองทุนสะสม (PANTA)",
    fundYieldUnavailable: "--/โปรดอัปเดตบริการ",
    effectiveVip: "ระดับที่มีผล",
    myHoldings: "ประวัติการซื้อกองทุน",
    faceValue: "มูลค่า",
    maturity: "ครบกำหนด",
    stakeStart: "เวลาที่สเตก",
    pantaPrice: "ราคา PANTA",
    noMoreHoldings: "ไม่มีรายการถือครองเพิ่มเติม",
    subscriptionStatus: {
      ACTIVE: "ใช้งานอยู่",
      SETTLED: "ชำระแล้ว",
      CANCELLED: "ยกเลิกแล้ว",
      MANUAL_REVIEW: "ตรวจสอบด้วยตนเอง",
    },
    minPanta: "ขั้นต่ำ PANTA",
    pantaAmount: "จำนวนสมัคร (PANTA)",
    stepHint: "ต้องเป็นจำนวนเท่าของ {step} ขั้นต่ำ {min}",
    getQuote: "ขอใบเสนอราคา",
    confirmStake: "ยืนยันการสเตก",
    jouleDebit: "หัก JOULE",
    expectedPanta: "PANTA ที่สเตก",
    quoteExpires: "ใบเสนอราคาหมดอายุ",
    unavailable: "ยังไม่เปิดให้บริการ",
    invalidAmount: "กรุณาใส่จำนวน PANTA ตามขั้นที่กำหนด",
    quoteFailed: "ขอใบเสนอราคาไม่สำเร็จ",
    rewards: "รางวัลกองทุน",
    unlock: "ชุด PANTA ที่ถูกแช่แข็ง",
    unlockProgress: "ปริมาณการเทรดที่ใช้แล้ว",
    pantaLedger: "บัญชี PANTA"
  },
  finanfund: {
    title: "PANTA MARKET Treasury Fund",
    subtitle: "ง่าย มีประสิทธิภาพ หารายได้ง่าย",
    productName: "PANTA MARKET Treasury Fund",
    minAmount: "จำนวนขั้นต่ำ",
    incomeRatio: "อัตราผลตอบแทน",
    lockPeriod: "ระยะเวลาล็อค",
    dailyReturn: "ผลตอบแทนรายวัน",
    earning: "ได้รับ",
    redemptionRules: "กฎการไถ่ถอน",
    rules: {
      rule1: "กองทุน TAKER Treasury ไม่สามารถไถ่ถอนได้หลังจากฝาก",
      rule2: "รายได้รายวันจะถูกเครดิตโดยอัตโนมัติ",
      rule3: "จำนวนที่ล็อคจะถูกคืนหลังจากสิ้นสุดระยะเวลาล็อค"
    },
    subscription: "สมัครสมาชิก",
    amountPlaceholder: "ป้อนจำนวน",
    balance: "ยอดคงเหลือ",
    availableFunds: "เงินทุนที่มี",
    all: "ทั้งหมด",
    subscribeButton: "สมัครสมาชิก",
    toasts: {
      productIdNotExist: "ไม่มี ID สินค้า",
      enterValidAmount: "กรุณาป้อนจำนวนการสมัครที่ถูกต้อง",
      minAmountRequired: "จำนวนการสมัครต้องไม่น้อยกว่า {amount} USDT",
      subscribeSuccess: "สมัครสมาชิกสำเร็จ",
      subscribeFailed: "สมัครสมาชิกล้มเหลว"
    }
  },
  community: {
    title: "ชุมชนอย่างเป็นทางการ",
    bannerTitle1: "เข้าร่วมชุมชนของเรา",
    bannerTitle2: "เชื่อมต่อกับผู้ใช้ทั่วโลก",
    linkCopied: "คัดลอกลิงก์แล้ว"
  },
  invite: {
    headerTitle: "เชิญเพื่อน",
    rulesEntry: "กฎการเชิญ",
    subtitle: "ได้จากทุกการเทรดของทีม",
    mainTitle: "เชิญแล้วได้",
    description: "แชร์ลิงก์ — เพื่อนเทรด คุณได้รางวัล",
    yourCode: "รหัสเชิญ",
    shareLink: "ลิงก์แชร์",
    inviteButton: "เชิญเพื่อน",
    subTitle: "รับค่าคอมมิชชั่นสูง",
    viewRules: "ดูกฎการแนะนำ",
    rulesLink: "ดู Vrules การอ้างอิง >",
    rulesTitle: "กฎการอ้างอิง",
    rules: {
      commissionTable: {
        title: "PANTA MARKET Trading Volume Commission Table",
        headers: {
          level: "Level",
          personalTurnover: "Personal Vol",
          teamTurnover: "Team Vol",
          commission: "Team Comm"
        }
      }
    },
    inviteBoxTitle: "เชิญเพื่อน",
    referralCode: "รหัสอ้างอิง",
    inviteLink: "ลิงก์เชิญ",
    loading: "กำลังโหลด...",
    copyButton: "คัดลอกลิงก์เชิญ",
    toasts: {
      emptyContent: "ไม่มีเนื้อหา",
      copySuccess: "คัดลอกสำเร็จ",
      bindSuccess: "ผูกสำเร็จ",
      bindFailed: "ผูกล้มเหลว",
      alreadyBound: "ผูกสายบนแล้ว เปลี่ยนไม่ได้",
      loginFirst: "กรุณาเชื่อมต่อกระเป๋าก่อน",
      invalidCode: "กรุณาใส่รหัสเชิญหรือที่อยู่กระเป๋าที่ถูกต้อง",
      cannotBindSelf: "ผูกตัวเองไม่ได้",
    },
    boundLabel: "ผูกสายบนแล้ว",
    modalDesc: "ยังไม่ได้ผูกสายบน กรอกรหัสเชิญหรือที่อยู่กระเป๋าเพื่อร่วมรางวัลทีม ข้อมูลจากลิงก์เชิญจะถูกเติมอัตโนมัติ หากไม่มีจะใช้ที่อยู่สายบนเริ่มต้น",
    bindPlaceholder: "ใส่รหัสเชิญหรือที่อยู่กระเป๋า",
    bindButton: "ผูก",
    binding: "กำลังผูก…",
    bindSuperior: "ผูกสายบน",
  },
  assets: {
    insuranceFrozen: "วงเงินแช่แข็งประกัน (JOULE)",
    available: "ใช้ได้",
    deposit: "ฝาก",
    withdraw: "ถอน",
    myAccountRecords: "บันทึกบัญชีของฉัน",
    nodeEquityHint: "Node equity valued in USDT, not a cash deposit",
    nodeEquityRate: "Applied rate: {rate}%",
    nodeEquitySources: {
      PERSONAL: "Personal insurance equity",
      TEAM: "Team insurance equity",
      ADMIN: "Platform Airdrop",
      AI_INSURANCE: "AI insurance node equity payout",
      BACKFILL: "AI insurance node equity backfill",
      OTHER: "Node equity credited",
    },
    recordTypes: {
      NODE_EQUITY_CREDIT: "Node equity credited",
      BET_STAKE: "อายัดเงินเดิมพัน",
      WIN_PAYOUT: "กำไรจากการเทรด",
      LOSS_SETTLEMENT: "ขาดทุนจากการเทรด",
      REFUND: "คืนเงิน",
      INSURANCE_PREMIUM: "รายจ่ายเบี้ยประกัน",
      INSURANCE_PAYOUT: "จ่ายประกัน",
      INSURANCE_TRANSFER_IN: "โอนเข้าประกัน",
      INSURANCE_TRANSFER_OUT: "โอนออกประกัน",
      NETWORK_DIFFERENTIAL: "รางวัลส่วนต่างการเทรด",
      NETWORK_PEER: "รางวัลระดับเดียวกัน",
      NETWORK_UNLOCK: "ปลดล็อกรายได้",
      EVENT_INSURANCE_PAYOUT: "จ่ายโหนดพลังคำนวณ",
      EVENT_INSURANCE_PEER: "รางวัลระดับเดียวกันของพลังคำนวณ",
      TRANSFER_IN: "โอนเข้า",
      TRANSFER_OUT: "โอนออก",
      PREMIUM_LOCK: "ล็อกเบี้ยประกัน",
      PREMIUM_SETTLE: "รายจ่ายเบี้ยประกัน",
      PREMIUM_REFUND: "คืนเบี้ยประกัน",
      WEALTH_SUBSCRIPTION: "จองซื้อกองทุน",
      SUBSCRIPTION_LOCK: "ล็อกสเตกกิ้ง",
      WEALTH_DAILY_REWARD: "ดอกเบี้ยรายวันกองทุน",
      WEALTH_TEAM_REWARD: "รางวัลทีมกองทุน",
      MATURITY_RELEASE: "คืนเงินต้นเมื่อครบกำหนด",
      WEALTH_UNLOCK: "ปลดล็อกรายได้",
      COPY_SHARE_HOLD: "Copy share held",
      COPY_SHARE_RELEASE: "Copy share unfrozen / refunded",
      COPY_SHARE_PAYOUT: "Copy share paid out",
      COPY_TRADE_TRANSFER_OUT: "Transfer to copy account",
      COPY_TRADE_TRANSFER_IN: "Transfer from copy account",
      COPY_WIN_PAYOUT: "Copy profit",
      COPY_LOSS_SETTLEMENT: "Copy loss",
      COPY_TRANSFER_IN: "Deposit to copy account",
      COPY_TRANSFER_OUT: "Withdraw from copy account",
      COPY_SHARE_PAYOUT_IN: "Copy share received",
      COPY_SHARE_POOL_IN: "Copy share pool in",
      COPY_SHARE_POOL_REFUND: "Copy share pool refund",
      COPY_SHARE_POOL_MIGRATION: "Copy share pool migration",
      COPY_FLOW: "Copy trade record"
    },
    recordCategories: {
      NODE_EQUITY: "Node equity",
      TRADE_PNL: "กำไร/ขาดทุนการเทรด",
      PREMIUM: "เบี้ยประกัน",
      INSURANCE_PAYOUT: "จ่ายประกัน",
      TEAM_REWARD: "รางวัลทีม",
      COPY: "Copy Details",
      COPY_TRADE_PNL: "Copy P&L",
      COPY_SHARE: "Copy share",
      COPY_TRANSFER: "Copy transfer",
      WEALTH_REWARD: "ดอกเบี้ยกองทุน",
      UNLOCK: "ปลดล็อก",
      PRINCIPAL: "จองซื้อ/คืนเงินต้น",
      TRANSFER: "โอนภายใน"
    },
    amountPendingReview: "จำนวนเงินรอตรวจสอบ",
    creditedSplit: "ใช้ได้ {available} · แช่แข็ง {frozen}",
    creditedSplitPending: "การแยกรอตรวจสอบ",
    afterBalance: "หลังเปลี่ยน: ใช้ได้ {available} · แช่แข็ง {frozen}",
    unlockHint: "แช่แข็ง → ใช้ได้ ไม่ใช่รายได้ใหม่",
    transferFromInsurance: "บัญชีประกัน",
    transferFromMain: "บัญชีหลัก",
    all: "ทั้งหมด",
    transfer: "โอน",
    insuranceDeduction: "หักประกัน",
    insurancePayout: "จ่ายประกัน",
    noRecords: "ไม่มีบันทึก",

    actions: {
      deposit: "ฝาก",
      withdraw: "ถอน",
      exchange: "แลกเปลี่ยน",
      transfer: "โอน"
    },
    loginPrompt: {
      text: "โปรดเชื่อมต่อกระเป๋าเงินของคุณก่อน",
      button: "เชื่อมต่อ"
    },
    toasts: {
      connectFailed: "การเชื่อมต่อล้มเหลว โปรดลองอีกครั้ง"
    },
    pantaUsdtRate: "1 PANTA = {price} USDT",
    buyNodeModal: {
      title: "Buy Trading Node",
      cancel: "Cancel Purchase",
      purchasing: "Purchasing...",
      confirm: "Confirm Purchase",
      availableBalance: "Available Balance",
      unavailable: "Not available yet",
      description: "Pay {amount}JOULE to get trading node access",
      insufficient: "Insufficient balance, please deposit first",
      success: "Purchase successful",
      failed: "Purchase failed, please retry"
    },
    transferToMain: "Transfer to Main System",
    mainSystemPanta: "Main System (PANTA)",
    jouleAvailable: "JOULE Available",
    detailTitle: "Asset Details",
    totalAssetsUsdt: "Estimated Total Value (USDT)",
    jouleConvert: "JOULE Converted (× rate)",
    usdtPart: "USDT Portion",
    totalSum: "Total",
    tradeFrozen: "Trade Frozen (JOULE)",
    financeReleaseFrozen: "Finance Release Frozen (JOULE)",
    insuranceAccountJoule: "Insurance (JOULE)",
    usdtAvailableLabel: "USDT Available",
    usdtFrozenLabel: "USDT Frozen",
    noHoldings: "No holdings yet",
    availableAssets: "Available Assets",
    tradeFrozenJoule: "Trade Frozen (JOULE)",
    payoutPower: "Compute Node Payout",
    payoutEquity: "AI Prediction Payout (JOULE)",
    mainAccount: "Trading",
    insuranceAccountShort: "Insurance",
    copyAccountShort: "คัดลอก",
    tradingAccountHelpTitle: "Trading account balance",
    copyAvailableLabel: "Available",
    copyFrozenLabel: "Frozen",
    copyAccountJoule: "บัญชีคัดลอก (JOULE)",
    copyTotalPnl: "PnL คัดลอก",
    transferSheet: {
      title: "โอน",
      pairCopy: "เทรด/คัดลอก",
      pairInsurance: "เทรด/ประกัน",
      tradingAccount: "บัญชีเทรด",
      copyAccount: "บัญชีคัดลอก",
      insuranceAccount: "บัญชีประกัน",
      jouleHint: "โอนได้เฉพาะ JOULE",
      submit: "ส่ง",
      transferring: "กำลังโอน...",
      success: "โอนสำเร็จ",
      failed: "โอนล้มเหลว กรุณาลองใหม่",
    },
    computeNode: "Compute Nodes",
    stakedTotalPanta: "Fund Staked",
    stakedPlusRewardPanta: "Stake + Est. Earnings",
    stakedPlusRewardTipTitle: "Stake principal + estimated earnings",
    stakedPlusRewardTip:
      "ตัวเลขนี้คือเงินต้นสтейกบวกผลตอบแทนโดยประมาณ",
    stakedPrincipalLabel: "เงินต้นสтейก",
    stakedExpectedYieldLabel: "ผลตอบแทนโดยประมาณ",
    annualEarningsPanta: "Fund Earnings",
    frozenTotalPanta: "Total Frozen",
    unlockedTotalPanta: "Total Unlocked",
    fundTeamPendingPanta: "ผลตอบแทนทีมกองทุนรอจ่าย (PANTA)",
    fundTeamPaidPanta: "ผลตอบแทนทีมกองทุนจ่ายแล้ว (PANTA)",
    pendingRewardPanta: "Pending Airdrop",
    paidRewardPanta: "Airdropped",
    expectedAirdropQuota: "Estimated Pending Airdrop",
    cumulativeAirdropValue: "มูลค่าแอร์ดรอปสะสม: {value} USDT",
    roundProgress: "Node Generation Progress",
    currentNodeCount: "Current Nodes",
    roundExpectedValue: "Est. this round: {value} USDT",
    historyTotalValue: "Historical total: {value} USDT",
    nextAirdropAt: "Next distribution: {time}",
    airdropEstimateUnavailable: "Unable to estimate",
    roundExpectedValueUnavailable: "Est. this round: unable to estimate",
    airdropEstimateHint: "Estimate only; actual settlement prevails",
    invalidNodeCount: "Invalid Nodes",
    deductedNodeCount: "Deducted Nodes",
    todayRelease: "Today Release",
    releaseFrozenPanta: "Release Frozen",
    unlockQuota: "Unlock Quota",
    unlockQuotaNote: "Today unlockable 0.0000",
    tradeNode: "Trade Node",
    tradeNodeDesc: "Upgrade to VIP3 and unlock trading benefits",
    tradeNodeHint: "Price: 2888 JOULE · Upgrade to VIP3",
    buyNode: "Buy Node",
    insuranceAccountRecordsShort: "Insurance"
  },
  wallet: {
    title: "กระเป๋าเงินของฉัน",
    address: "ที่อยู่กระเป๋าเงิน",
    addressCopied: "คัดลอกที่อยู่แล้ว",
    inviteCode: "รหัสเชิญชวน",
    logout: "ออกจากระบบ",
    login: "เข้าสู่ระบบ",
    toasts: {
      networkSwitchCancelled: "ผู้ใช้ยกเลิกการสลับเครือข่าย",
      networkConfigNotFound: "ไม่พบการกำหนดค่าเครือข่ายสำหรับ {chainId}",
      signatureCancelled: "ผู้ใช้ยกเลิกการลงนาม",
      connectionFailed: "ไม่สามารถเชื่อมต่อกระเป๋าเงิน",
      accountSwitched: "บัญชีกระเป๋าเงินถูกสลับ โปรดเชื่อมต่อใหม่",
      connectionTimedOut: "การเชื่อมต่อหมดเวลา โปรดลองอีกครั้ง",
      loginSuccess: "เข้าสู่ระบบสำเร็จ",
      logoutSuccess: "ออกจากระบบสำเร็จ",
      switchNetwork: "โปรดสลับไปยัง {chainName} ในกระเป๋าเงินของคุณก่อนที่จะพยายามฝากเงิน",
      wrongChain: "เครือข่ายไม่รองรับ โปรดสลับไปยัง {chainName}",
      switchingNetwork: "กำลังสลับเครือข่าย...",
      switchNetworkFailed: "การสลับเครือข่ายล้มเหลว โปรดสลับไปยัง {chainName} ในกระเป๋าเงินของคุณด้วยตนเอง"
    }
  },
  market: {
    title: "ตลาด",
    banner: {
      title: "สัญญาเหตุการณ์",
      desc: "ปลดปล่อยศักยภาพการสร้างรายได้บน On-chain"
    },
    tabs: {
      main: "เหรียญหลัก",
      rise: "อันดับเพิ่มขึ้น"
    },
    types: {
      crypto: "สกุลเงินดิจิทัล",
      stocks: "หุ้นสหรัฐ",
      forex: "ฟอเร็กซ์",
      commodities: "สินค้า",
      favorites: "รายการโปรด"
    },
    headers: {
      pair: "คู่เทรด",
      price: "ราคาล่าสุด",
      change: "เปลี่ยนแปลงวันนี้"
    },
    loading: "กำลังโหลด...",
    loadingMore: "กำลังโหลดเพิ่มเติม...",
    noMoreData: "ไม่มีข้อมูลเพิ่มเติม"
  },
  notice: {
    loginRequired: "กรุณาเข้าสู่ระบบเพื่อดูประกาศ",
    empty: "ยังไม่มีประกาศ",
    unpublished: "ยกเลิกเผยแพร่",
    title: "ประกาศ",
    helpCenter: "ศูนย์ช่วยเหลือ",
    noticeDetail: "รายละเอียดประกาศ",
    viewDetail: "ดูรายละเอียด",
    pdfViewer: "ตัวดู PDF",
    videoPlayer: "เครื่องเล่นวิดีโอ",
    imageViewer: "ตัวดูรูปภาพ",
    documentViewer: "ตัวดูเอกสาร",
    clickToViewPdf: "คลิกเพื่อดู PDF",
    clickToViewDocument: "คลิกเพื่อดูเอกสาร",
    openInBrowser: "เปิดในเบราว์เซอร์",
    tryingViewer: "กำลังลองวิธี {current}/{total}",
    pdfLoadFailed: "โหลดตัวอย่าง PDF ล้มเหลว กรุณาดาวน์โหลดเพื่อดู",
    downloadPdf: "ดาวน์โหลด PDF",
    defaultCategory: "Notice"
  },
  trade: {
    title: "สัญญาเหตุการณ์",
    nextRound: "รอบถัดไป",
    posCurrent: "ปัจจุบัน",
    aiThenPrefix: 'AI ตอนนั้น: ',
    aiUnlinked: 'ไม่ได้เชื่อม AI',
    aiNotRecorded: 'ไม่มีบันทึก',
    insuranceLabel: "ประกัน",
    insuranceNotSelected: 'ไม่ได้เลือก',
    insuranceInactive: "ยังไม่มีผล",
    insuranceTypeNone: "ยังไม่มีผล",
    insuranceTypeEvent: "ประกันทั่วไปมีผล",
    insuranceTypeEventShort: "ประกันทั่วไป",
    insuranceTypeAi: "ประกัน AI มีผล",
    insuranceTypeAiShort: "ประกัน AI",
    insuranceTypeConverted: "ออเดอร์นี้ถูกเปลี่ยนเป็นประกันทั่วไป",
    insuranceTypeUnknown: "สถานะประกันรอการยืนยัน",
    inProgress: "กำลังดำเนินการ",
    estimatedPnl: "กำไรขาดทุนโดยประมาณ",
    settlementConfirming: "กำลังยืนยันผล",
    balanceSyncing: "กำลังซิงค์ยอดเงิน",
    pendingReview: "รอตรวจสอบ",
    connecting: "กำลังเชื่อมต่อ...",
    connectWallet: "เชื่อมต่อ",
    orderDetail: {
      title: "รายละเอียดคำสั่ง",
      orderId: "รหัสคำสั่ง",
      symbol: "คู่เทรด",
      interval: "ช่วงเวลา",
      direction: "ทิศทาง",
      aiDirection: "AI ตอนนั้น",
      openTime: "เวลาเปิด",
      settleTime: "หมดอายุ",
      settledAt: "เวลาชำระ",
      openPrice: "ราคาเปิด",
      closePrice: "ราคาปิด",
      stake: "เงินต้น",
      premium: "เบี้ยประกัน",
      netProfit: "กำไร/ขาดทุนสุทธิ",
      status: "สถานะ",
      orderSource: "แหล่งคำสั่ง",
      converted: "การแปลงประกัน",
      notRecorded: "ไม่มีบันทึก",
      copied: "คัดลอกรหัสคำสั่งแล้ว",
    },
    orderStatus: {
      CREATED: "สร้างแล้ว",
      ACCEPTED: "รับแล้ว",
      CLOSED: "ปิดแล้ว",
      FUNDS_LOCKED: "ล็อกเงินแล้ว",
      AWAITING_SETTLEMENT: "รอชำระ",
      PROCESSING: "กำลังดำเนินการ",
    },
    insuranceBalanceInsufficient: "ยอดบัญชีประกันไม่เพียงพอ",
    mainBalanceInsufficient: "ยอดบัญชีหลักไม่เพียงพอ",
    insuranceBalanceRequired: "ยอดบัญชีประกันไม่เพียงพอ ไม่สามารถเปิดประกันได้",
    insuranceRulesUnavailable: "กฎเบี้ยประกันยังไม่พร้อม ไม่สามารถเปิดประกันได้",
    insuranceMainRequired: "ยอดบัญชีหลักไม่เพียงพอ ไม่สามารถเปิดประกันได้",
    preferenceLoading: "กำลังโหลดการตั้งค่าประกัน",
    preferenceLoadFailed: "โหลดการตั้งค่าประกันไม่สำเร็จ แตะเพื่อลองใหม่",
    preferenceSaveFailed: "บันทึกการตั้งค่าประกันไม่สำเร็จ โปรดลองใหม่",
    preferenceSessionEndedSaveFailed: "รอบสิ้นสุดแล้ว แต่การตั้งค่าปิดยังไม่ได้บันทึก",
    premiumEstimate: "เบี้ยประกันโดยประมาณ {premium} JOULE ({rate}%)",
    premiumShortfallHint: "บัญชีประกันขาดอีก {amount} JOULE",
    premiumEstimateUnavailable: "ยังไม่สามารถประมาณเบี้ยประกันได้",
    premiumBoundEstimate: "เบี้ยประกันโดยประมาณของกลยุทธ์ที่ผูกไว้ {premium} JOULE",
    insuranceConfirmTitle: "ยืนยันเบี้ยประกัน",
    insuranceConfirmBody: "ตัวอย่างเบี้ยประกัน {premium} JOULE ตัวอย่างนี้ถือเป็นยอดสุดท้าย ยืนยันเพื่อส่ง",
    actions: {
      rise: "Long",
      fall: "Short",
      buy: "ซื้อ",
      sell: "ขาย"
    },
    holdings: {
      current: "ตำแหน่ง",
      history: "ประวัติการซื้อขาย",
      currentCount: "สถานะที่เปิดอยู่ {n}",
      empty: "ไม่มีตำแหน่ง",
      historyEmpty: "ไม่มีประวัติ"
    },
    position: {
      openPrice: "ราคาเปิด",
      closePrice: "ราคาปิด",
      profitLoss: "กำไร/ขาดทุน",
      countdown: "ชำระเงินใน",
      calculating: "กำลังคำนวณ...",
      settled: "ชำระแล้ว",
      settling: "กำลังชำระ",
      active: "ใช้งาน",
      settledAt: "ชำระเมื่อ"
    },
    modal: {
      amountPlaceholder: "ป้อนจำนวนเงิน"
    },
    pairSelector: {
      title: "เลือกคู่เทรด",
      searchPlaceholder: "ค้นหาเหรียญ"
    },
    errors: {
      dataNotReady: "กำลังโหลดข้อมูล กรุณารอสักครู่"
    },
    marketPause: {
      default: "ตลาดยังไม่พร้อมใช้งาน โปรดลองใหม่ภายหลัง",
      lastPriceStreamWarming: "กำลังเตรียมราคาล่าสุด โปรดลองใหม่ในอีกสักครู่",
      marketWarming: "ตลาดกำลังเตรียมความพร้อม โปรดลองใหม่ในอีกสักครู่",
      recovering: "กำลังกู้คืนตลาด โปรดลองใหม่ในอีกสักครู่",
      clockNotSynced: "เวลานาฬิกาเซิร์ฟเวอร์ยังไม่ซิงก์ โปรดลองใหม่ในอีกสักครู่",
      symbolUnavailable: "คู่เทรดนี้ยังไม่เปิดให้บริการ"
    },
    toasts: {
      connectSuccess: "เชื่อมต่อสำเร็จ",
      connectCancelled: "คุณได้ยกเลิกการเชื่อมต่อ",
      connectFailed: "การเชื่อมต่อล้มเหลว"
    },
    openPriceLabel: "ราคาเปิด",
    secondsUnit: "s",
    amountLabel: "จำนวน",
  },
  exchange: {
    title: "แลกเปลี่ยนทันที",
    from: "จาก",
    to: "ถึง",
    balance: "ยอดคงเหลือ",
    all: "ทั้งหมด",
    placeholder: "โปรดป้อน",
    fee: "ค่าธรรมเนียม",
    minAmount: "จำนวนแลกเปลี่ยนขั้นต่ำ: {amount} {symbol}",
    button: "แลกเปลี่ยน",
    tradeButton: "ซื้อขาย",
    paymentCurrency: "สกุลเงินชำระ",
    estimatedGasFee: "ค่าแก๊สโดยประมาณ",
    gasPaymentNote: "จะใช้ยอดคงเหลือ GetGas เพื่อชำระค่าแก๊ส",
    slippage: "การเลื่อนราคา",
    auto: "อัตโนมัติ",
    approximately: "ประมาณ",
    minReceived: "รับขั้นต่ำ",
    exchangeRate: "อัตราแลกเปลี่ยน",
    finalAmount: "จำนวนสุดท้าย",
    confirm: "ยืนยัน",
    swapSuccess: "แลกเปลี่ยนทันทีสำเร็จ!",
    swapping: "กำลังแลกเปลี่ยน...",
    confirmTitle: "ยืนยันการกระทำ",
    confirmContent: "คุณแน่ใจหรือไม่ว่าต้องการดำเนินการต่อ?",
    toasts: {
      fetchFailed: "ไม่สามารถดึงข้อมูลสินทรัพย์ได้",
      enterValidAmount: "โปรดป้อนจำนวนที่ถูกต้อง",
      minAmount: "จำนวนแลกเปลี่ยนขั้นต่ำคือ {amount} {symbol}",
      swapSuccess: "แลกเปลี่ยนสำเร็จ",
      requestFailed: "ส่งคำขอล้มเหลว",
      insufficientBalance: "ยอดเงินไม่เพียงพอ ไม่สามารถแลกเปลี่ยนได้",
      usdtRestricted: "USDT under review; exchange unavailable"
    },
    rateHint: "{usdt} USDT={joule}JOULE, no fee",
    configFee: "ค่าธรรมเนียม Joule → USDT {fee}",
    configLimits: "ค่าธรรมเนียม {fee} · วงเงินมูลค่าก่อนหัก {min}–{max} U",
    unlimited: "ไม่จำกัด",
    quoteFailed: "ไม่สามารถดึงใบเสนอราคาได้ โปรดลองอีกครั้ง"
  },
  globalNode: {
    title: "โหนดทั่วโลก"
  },
  eventInsurance: {
    title: "ประกันสัญญาเหตุการณ์",
    availableBalance: "ยอดคงเหลือที่ใช้ได้ (USDT)",
    fundTransfer: "โอนเงิน",
    fundHistory: "ประวัติเงิน",
    type: "ประเภท: ",
    all: "ทั้งหมด",
    transfer: "โอน",
    fundTransferTitle: "โอนเงิน",
    currency: "สกุลเงิน",
    from: "จาก",
    to: "ถึง",
    availableAccount: "บัญชีที่ใช้ได้",
    contractInsuranceAccount: "บัญชีประกันสัญญา",
    pleaseEnter: "กรุณากรอก",
    confirmTransfer: "ยืนยันการโอน",
    insufficientBalance: "ยอดเงินไม่เพียงพอ",
    transferSuccess: "โอนสำเร็จ",
    transferFailed: "โอนไม่สำเร็จ",
    transferring: "กำลังโอน...",
    noRecords: "ไม่มีบันทึก",
    selectAccount: "เลือกบัญชี",
    cannotTransferToSameAccount: "ไม่สามารถโอนไปยังบัญชีเดียวกันได้",
    cannotTransferContractAccount: "ไม่รองรับการโอนบัญชีสัญญา",
    contractAccount: "บัญชีสัญญา (TAKER)",
    rulesTab: "สรุป",
    agreementTab: "ข้อตกลงฉบับเต็ม",
    insuranceRulesTitle: "Insurance Rules",
    preview: {
      eventGroup: "一.กฎการทำนายสัญญาเหตุการณ์",
      eventOpen: {
        title: "1. เปิดประกัน",
        points: [
          "เปิดประกันแล้ว คิดเบี้ยตามสัดส่วนออเดอร์/ยอดคงเหลือ: ≤10% → 15%; เกิน → 20%",
          "หากยอดบัญชีประกันไม่พอ ประกันไม่มีผล"
        ]
      },
      eventLimit: {
        title: "2. เพดานออเดอร์",
        points: [
          "สูงสุดต่อออเดอร์ 5,000 JOULE"
        ]
      },
      eventClaim: {
        title: "3. กฎสิทธิ์ชดเชย",
        ok: [
          "50% เข้าโควตาแอร์ดรอปส่วนบุคคล สะสม 50 USD ได้ 1 โหนด",
          "30% เข้าโควตาชุมชนตาม VIP สะสม 50 USD ได้ 1 โหนด"
        ],
        fail: [
          "เสียเงินต้นทั้งหมด จบการทำนาย"
        ]
      },
      eventPool: {
        title: "4. การจ่ายพูลประกันเหตุการณ์:",
        points: [
          "2% ของสินทรัพย์พูลรายวันเป็น PANTA แอร์ดรอปตามน้ำหนักโหนด",
          "เมื่อแอร์ดรอปรายวันถึง 50 USD เทียบ PANTA จะลด 1 โหนด"
        ]
      },
      eventProfit: {
        title: "5. กฎกำไร/ขาดทุน",
        points: [
          "ถูก: ได้เงินต้น 100% + กำไร (80%)",
          "ผิด: เสียเงินต้นทั้งหมด จบการทำนาย"
        ]
      },
      aiGroup: "二.กฎการทำนาย AI",
      aiFirst: {
        title: "1. ออเดอร์แรกต้องกรอกเอง"
      },
      aiOpen: {
        title: "2. เปิดประกัน",
        points: [
          "เปิดประกันแล้ว จ่ายเบี้ย 5%–10% ของขนาดสถานะ",
          "หากยอดประกันไม่พอ ประกันไม่มีผล"
        ]
      },
      aiLimit: {
        title: "3. ข้อจำกัดออเดอร์",
        points: [
          "จำนวนต้องตามตารางสถานะ และทิศทางตรงกับ AI",
          "ไม่ตามตาราง → เปลี่ยนเป็นการทำนายเหตุการณ์ปกติ",
          "แพ้ติดกัน 8 ออเดอร์ → สิทธิ์ชดเชยตามสัดส่วน",
          "ออเดอร์กำไรจะรีเซ็ตลำดับเป็นขั้นที่ 1"
        ]
      },
      table: {
        level: "ระดับบัญชี",
        order1: "ออเดอร์1",
        order2: "ออเดอร์2",
        order3: "ออเดอร์3",
        order4: "ออเดอร์4",
        order5: "ออเดอร์5",
        order6: "ออเดอร์6",
        order7: "ออเดอร์7",
        order8: "ออเดอร์8"
      },
      claimOk: "เข้าเงื่อนไขชดเชย",
      claimFail: "ไม่เข้าเงื่อนไข",
      claimFailWhen: "เมื่อไม่เข้าเงื่อนไข:",
      claimPrereq: "เงื่อนไขเบื้องต้น:",
      aiClaim: {
        title: "4. กลไกสิทธิ์ชดเชย",
        prereq: [
          "เปิดประกันแล้ว",
          "ทิศทางตรง AI",
          "จำนวน/ลำดับตามตาราง",
          "ครบเงื่อนไขชำระ"
        ],
        ok: [
          "ชดเชยเงินสด = ขาดทุนสะสม × 90%"
        ],
        fail: [
          "เสียเงินต้นทั้งหมด จบการทำนาย"
        ]
      },
      aiProfit: {
        title: "5. กฎกำไร",
        points: [
          "ถูก: เงินต้น 100% + กำไร 80%",
          "ผิด: เสียเงินต้น จบหรือรับชดเชย"
        ]
      }
    },
    rulesContent: "PANTA Market ข้อตกลงประกันภัยแผนคุ้มครองการซื้อขายสัญญาเหตุการณ์\n\n【ประกาศสำคัญ】ก่อนใช้บริการนี้ โปรดอ่านและทำความเข้าใจเนื้อหาข้อตกลงทั้งหมดอย่างละเอียด ระบบจะถือว่าการที่ผู้ใช้เปิด「สวิตช์ประกันภัย」หมายความว่าท่านได้อ่าน เข้าใจ และยอมรับข้อตกลงและเอกสารแนบอย่างครบถ้วน ยืนยันว่าข้อตกลงมีผลผูกพันทางกฎหมาย และตกลงปฏิบัติตามอย่างเคร่งครัด หากไม่ยอมรับ โปรดหยุดใช้แผนคุ้มครองนี้ทันที\n\nข้อ 1: บทบัญญัติทั่วไปและขอบเขตการใช้บังคับ\n\n1.1 ข้อตกลงนี้ใช้อธิบายวิธีการเข้าร่วม การก่อตั้งคำสั่ง ค่าธรรมเนียม การตัดสินผล การชำระเงิน การชดเชยตามเงื่อนไข และสิทธิประโยชน์โหนดที่เกี่ยวข้อง รวมถึงฟังก์ชันทำนายเหตุการณ์ของฟังก์ชัน「ทำนายสัญญาเหตุการณ์」และ「ทำนายสัญญาเหตุการณ์ AI」ภายใน PANTA Market ทั้งสองผลิตภัณฑ์ใช้ข้อกำหนดเฉพาะของตนเอง ไม่สามารถนำอัตรา เงื่อนไขการชดเชย หรือกฎโหนดของผลิตภัณฑ์หนึ่งไปใช้กับอีกผลิตภัณฑ์โดยตรง\n1.2 การทำนายสัญญาเหตุการณ์คือฟังก์ชันที่ผู้ใช้ตัดสินใจเกี่ยวกับเหตุการณ์ที่ระบุไว้ล่วงหน้าและผลลัพธ์ที่เลือกได้ โดยใช้ JOULE ส่งและสร้างคำสั่ง ขาดทุนที่มีคุณสมบัติขั้นสุดท้ายสามารถสร้างวงเงินโหนดส่วนบุคคลหรือทีมชุมชนตามกฎที่อนุมัติ วงเงินดังกล่าวไม่ใช่การชดเชยเงินสดทันที การทำนายสัญญาเหตุการณ์ AI คือฟังก์ชันที่ผู้ใช้อ้างอิงสัญญาณทิศทางทำนาย AI ที่มีผลจากระบบ ยืนยันเข้าร่วมทีละรายการตามจำนวนเงินคงที่และลำดับของแผนที่เลือกเพื่อสร้างคำสั่ง เมื่อคำสั่ง 8 รายการในลำดับที่มีคุณสมบัติเดียวกันชำระครบและขาดทุนทั้งหมด พร้อมปฏิบัติตามเงื่อนไขอื่นที่ระบุชัดเจน จะคำนวณชดเชย JOULE 90% ของเงินต้นรวมที่มีคุณสมบัติ สัญญาณ AI ไม่ใช่การรับประกันผลลัพธ์ และการชดเชยตามเงื่อนไขไม่ครอบคลุมค่าใช้จ่ายทั้งหมด\n1.3 ข้อตกลงนี้ พารามิเตอร์เวอร์ชันของผลิตภัณฑ์ที่เกี่ยวข้อง กฎเหตุการณ์เฉพาะ และหน้ายืนยันผู้ใช้ ร่วมกันครอบคลุมกฎที่สมบูรณ์ หน้าเว็บแสดงได้เฉพาะพารามิเตอร์ที่อนุมัติแล้ว ห้ามใช้「ยึดตามหน้าเว็บ」แทนการขาดเงื่อนไขสำคัญ เมื่อเอกสารขัดแย้งกัน ต้องหยุดธุรกรรมใหม่ที่ได้รับผลกระทบและอธิบาย ตรวจสอบ และแก้ไข ห้ามเลือกการตีความที่ไม่เป็นประโยชน์ต่อผู้ใช้ภายหลังเพื่อจัดการคำสั่งเดิม\n1.4 โครงการนี้เกี่ยวข้องกับสินทรัพย์จริง การทำนายเหตุการณ์ การชดเชยตามเงื่อนไข ชื่อเรียกประกันภัย รางวัลทีม การแลกเปลี่ยน และกองทุน ไม่ใช่ผลิตภัณฑ์ที่สามารถข้ามการตรวจสอบความเสี่ยงและการปฏิบัติตามกฎ ลักษณะทางกฎหมาย ใบอนุญาต พื้นที่ให้บริการ คุณสมบัติผู้ใช้ AML การคุ้มครองผู้บริโภค และข้อกำหนดการประมวลผลข้อมูลของแต่ละฟังก์ชัน ต้องตรวจสอบอย่างมืออาชีพตามขอบเขตบริการจริง ข้อจำกัดความรับผิดไม่สามารถแทนใบอนุญาต การจัดสรรเงิน และมาตรการควบคุมที่จำเป็น ฉบับร่างนี้ไม่สมมติว่าใช้กฎหมายของประเทศใด และไม่ถือว่าผลิตภัณฑ์ได้รับอนุญาตให้ดำเนินการอย่างถูกต้องแล้ว\n\nข้อ 2: คำศัพท์และสถานะเงิน\n\n2.1 JOULE คือหน่วยที่ใช้วัดเงินต้นทำนาย ค่าเบี้ยประกัน และการชดเชย AI ในการออกแบบผลิตภัณฑ์นี้ PANTA คือหน่วยสินทรัพย์ที่ใช้ในการจัดสรรสิทธิประโยชน์โหนดและธุรกิจอื่น มูลค่าเทียบเท่า USDT คือเกณฑ์วัดที่ใช้สำหรับวงเงินและการคำนวณมูลค่าบางส่วน ทั้งสามไม่สามารถใช้ปนกันได้ การแสดงตัวเลขภายในไม่หมายความว่าสามารถแลกเป็นเงินตราตามอัตราแลกเปลี่ยนคงที่ได้ทันที และไม่เท่ากับการโอนสินทรัพย์บนเชนสำเร็จแล้ว คำอธิบายนี้ไม่ยกเลิกสิทธิในสินทรัพย์หรือหน้าที่ชำระเงินที่เกิดขึ้นตามกฎหมายและสัญญา\n2.2 เงินต้นคำสั่งคือจำนวน JOULE ที่ผู้ใช้ยืนยันจริงและระบบรับในคำสั่งนั้น ไม่รวมค่าเบี้ยประกัน ค่าเบี้ยประกันคือค่าใช้จ่ายที่คำนวณตามกฎที่ใช้กับคำสั่งนั้น ยอดแช่แข็งรวมโดยทั่วไปคือผลรวมของเงินต้นและค่าเบี้ยประกัน หากมีค่าใช้จ่ายอื่นต้องเปิดเผยแยกล่วงหน้า ห้ามเพิ่มค่าธรรมเนียมที่ไม่ได้ยืนยันเมื่อชำระ\n2.3 ยอดคงเหลือที่ใช้ได้คือยอดที่ใช้สำหรับการดำเนินการใหม่ภายใต้กฎบัญชีปัจจุบัน ยอดแช่แข็งคือยอดที่สำรองไว้สำหรับคำสั่งที่รับหรือธุรกิจที่อนุมัติ ชั่วคราวไม่สามารถใช้สำหรับการดำเนินการอื่น รายได้ที่คาดการณ์ การชดเชยรอตรวจ วงเงินโหนด และการจัดสรรที่ยังไม่บันทึกไม่นับรวมในยอดคงเหลือที่ใช้ได้ การแสดงยอดต้องระบุชื่อสินทรัพย์ ไม่อนุญาตให้รวมจำนวนสินทรัพย์ต่างชนิดโดยตรง\n2.4 ลำดับ AI คือบันทึกธุรกิจที่เชื่อมต่อจากรายการที่ 1 ตามกฎสำหรับแผนที่ยืนยันแล้วเดียวกัน ขั้นตอนปัจจุบัน ผลคำสั่ง และหลักฐานคุณสมบัติดูแลโดยเซิร์ฟเวอร์ การขาดการเชื่อมต่อปกติหรือออกจากแอปไม่ถือเป็นการสิ้นสุดธุรกิจลำดับ การรีเซ็ตคือการสิ้นสุดลำดับเก่าหลังปฏิบัติตามเงื่อนไขที่กำหนดในข้อตกลงนี้\n2.5 วงเงินโหนดพลังการคำนวณคือหน่วยบันทึกเทียบเท่า USDT ที่สะสมตามกฎจากขาดทุนที่มีคุณสมบัติขั้นสุดท้าย ใช้สร้างโหนด โหนดคือบันทึกคุณสมบัติเข้าร่วมการจัดสรรสิทธิประโยชน์ในภายหลัง ไม่ใช่เงินสดทันที PANTA ที่เข้าบัญชีแล้ว และไม่กลายเป็น NFT บนเชนที่ซื้อขาย สเตก หรือโอนได้อย่างอิสระเพียงเพราะชื่อ\n2.6 สแนปช็อตกฎคือเวอร์ชันกฎ พารามิเตอร์ จำนวนเงิน หลักฐานราคา ข้อกำหนด และหลักฝากที่เกี่ยวข้องที่บันทึกเมื่อยืนยันคำสั่งหรือลำดับ การเผยแพร่เวอร์ชันใหม่ไม่สามารถเขียนทับสแนปช็อตเก่า บันทึกเซิร์ฟเวอร์ใช้ตรวจสอบสถานะการดำเนินการ แต่ผู้ใช้สามารถให้หลักฐานอื่นเพื่อขอตรวจสอบใหม่ ไม่สามารถยกเว้นข้อโต้แย้งที่สมเหตุสมผลเพียงเพราะบันทึกเก็บโดยแพลตฟอร์ม\n\nข้อ 3: คุณสมบัติการใช้งานและการยืนยันข้อตกลง\n\n3.1 แพลตฟอร์มสามารถให้ฟังก์ชันที่เกี่ยวข้องแก่ผู้ใช้ในพื้นที่บริการ ช่วงอายุ และความเหมาะสมที่อนุมัติแล้วเท่านั้น เวอร์ชันอย่างเป็นทางการต้องระบุข้อกำหนดการยืนยันตัวตน ขอบเขตผลิตภัณฑ์ที่ใช้ได้ และเหตุผลการจำกัด ไม่สามารถถือว่ามีคุณสมบัติเข้าร่วมทุกผลิตภัณฑ์เพียงเพราะกระเป๋าเงินเชื่อมต่อ หน้าจอแสดง หรือบัญชีมียอดคงเหลือ\n3.2 ผู้ใช้ต้องใช้บัญชีและสินทรัพย์ที่ตนมีสิทธิควบคุม ห้ามแอบอ้าง ใช้บัญชีผู้อื่นโดยไม่ได้รับอนุญาต ปลอมเอกสารคุณสมบัติ หรือจัดการสัญญาณหรือหลักฐานผลลัพธ์ เมื่อแพลตฟอร์มต้องการตรวจสอบเพิ่มเติม ต้องอธิบายเอกสารที่ต้องการและวัตถุประสงค์ธุรกิจ การจำกัดการเข้าร่วมใหม่และการดำเนินการคำสั่งเดิมต้องอธิบายแยกกัน\n3.3 ก่อนสั่งซื้อ ผู้ใช้ต้องสามารถดูเงินต้น ค่าเบี้ยประกัน ค่าใช้จ่ายเพิ่มเติมที่เป็นไปได้ ตัวเลือกทำนาย ขาดทุนที่เลวร้ายที่สุด เงื่อนไขการชำระ แหล่งที่มาการตัดสิน และเส้นทางข้อพิพาท แพลตฟอร์มต้องมีขั้นตอนยืนยันที่ชัดเจน ห้ามใช้การยอมรับค่าเริ่มต้น ค่าใช้จ่ายที่ซ่อน การสลับจำนวนเงินอัตโนมัติ หรือการเร่งให้ทำซ้ำแทนการยืนยันที่แท้จริงของผู้ใช้\n3.4 สัญญาณ AI ผลลัพธ์ในอดีต ตัวอย่างรายได้ ขนาดพูลโหนด และบันทึกสิทธิประโยชน์ของผู้อื่นไม่ถือเป็นคำมั่นสัญญาผลลัพธ์ในอนาคต ผู้ใช้อาจสูญเสียเงินต้นคำสั่งที่รับและค่าเบี้ยประกันที่เกี่ยวข้อง สิทธิประโยชน์โหนดอาจได้รับผลจากยอดพูล น้ำหนักที่มีผล ราคา และสถานะการประมวลผล ผู้ใช้ไม่ควรถือตัวอย่างใดเป็นผลตอบแทนคงที่หรือระยะเวลารับคืนที่แน่นอนของตนเอง\n\nข้อ 4: กฎการทำนายสัญญาเหตุการณ์\n\n4.1 ก่อนเริ่มลำดับ AI ผู้ใช้ต้องดูแผนที่ใช้ได้ เงินต้นตำแหน่งที่ดำเนินการ ค่าเบี้ยประกันที่คาดการณ์ ความต้องการเงินรวม ระยะเวลาสัญญาณ กฎชำระ 60 วินาที และเงื่อนไขชดเชย 90% ลำดับใหม่เริ่มได้จากรายการที่ 1 เท่านั้น ห้ามเปลี่ยนแผนระหว่างลำดับ ผู้ใช้ไม่สามารถใช้การข้ามขั้น เปลี่ยนจำนวน หรือคำสั่งค้างคู่ขนานเพื่อรวมเป็นลำดับที่มีคุณสมบัติใหม่ หลังผู้ใช้เลือกผลเหตุการณ์และป้อนเงินต้น JOULE แพลตฟอร์มคำนวณค่าเบี้ยประกันตามฐานตำแหน่งที่อนุมัติ การออกแบบปัจจุบัน: เงินต้นไม่เกิน 10% ของฐานตำแหน่ง ค่าเบี้ย 15% ของเงินต้น เกิน 10% ค่าเบี้ย 20% ของเงินต้น ที่ขอบเขต 10% พอดีใช้ 15%\n4.2 สัญญาณ AI ต้องแสดงสินทรัพย์ ทิศทาง เวลา ระยะเวลามีผล และหมายเลขสัญญาณที่ระบุได้ ผู้ใช้ต้องยืนยันทิศทางตรงกับสัญญาณที่มีผลขณะนั้นเมื่อสั่งซื้อ สัญญาณอัปเดตระหว่างรอหรือเชื่อมต่อใหม่ต้องตรวจสอบใหม่ สัญญาณหมดอายุไม่สามารถใช้ต่อจากแคชไคลเอนต์ การใช้สัญญาณ AI ไม่หมายความว่าแพลตฟอร์มหรืออัลกอริทึมรู้ผลลัพธ์ในอนาคต ความแม่นยำในอดีต บันทึกสาธิต และคำอธิบายการทำนายไม่สามารถรับประกันผลของรายการนี้ แพลตฟอร์มห้ามใช้คำว่า「ชนะแน่」「กำไรมั่นใจ」หรือ「ผิดก็ไม่เสีย」แทนเงินต้น ค่าเบี้ยประกัน และเงื่อนไขชดเชยจริง\n4.3 แต่ละเหตุการณ์ต้องระบุชื่อ คำอธิบายข้อเท็จจริง ผลลัพธ์ที่เลือกได้ เวลาเปิดและปิด เขตเวลา วงเงินเข้าร่วม เกณฑ์ตัดสินผล แหล่งหลักและสำรอง การคำนวณกำไร ขาดทุนเลวร้ายที่สุด กฎยกเลิกหรือเลื่อน และขั้นตอนอุทธรณ์แยกกัน สำหรับเหตุการณ์คลุมเครือ ขาดเกณฑ์ตัดสิน หรือพารามิเตอร์เศรษฐกิจสำคัญยังไม่อนุมัติ ห้ามเปิดสั่งซื้อจริง แพลตฟอร์มต้องตรวจสอบเมื่อรับคำสั่งว่าเหตุการณ์ยังเปิด เวลาเซิร์ฟเวอร์ก่อนปิด ตัวเลือกและเวอร์ชันมีผล คุณสมบัติและวงเงินผู้ใช้เพียงพอ ยอดคงเหลือเพียงพอ การตัดสินปิดไม่ยึดเวลาอุปกรณ์ผู้ใช้ หรือว่าไคลเอนต์ยังแสดงนับถอยหลังเมื่อคลิก\n4.4 หลังแช่แข็งเงินต้นและค่าเบี้ยประกันสำเร็จและรับคำสั่ง แพลตฟอร์มส่งคืนเวลารับและจุดเวลาชำระที่ตกลง จุดเวลานั้นคำนวณจากเวลารับเซิร์ฟเวอร์บวก 60 วินาที ไม่นับจากเปิดหน้า รับสัญญาณ หรือคลิกปุ่ม ความล่าช้าเครือข่ายไม่ย่อหรือขยายเกณฑ์ตัดสินที่กำหนดแล้ว 60 วินาทีหมายถึงจุดเวลาตัดสินผลที่ตกลง ไม่สัญญาว่าเงินเข้าบัญชีทันทีเมื่อนับถอยหลังไคลเอนต์เป็นศูนย์ หลังถึงจุดเวลา ต้องได้หลักฐานผลจากแหล่งที่ตกลง หากไม่มีหลักฐาน แหล่งผิดปกติ หรือผลขัดแย้ง ให้คงสถานะรอชำระและอธิบาย ห้ามบันทึกเป็นขาดทุนอัตโนมัติ\n4.5 เฉพาะเมื่ออยู่ในลำดับที่มีผลปัจจุบัน กฎแสดงชัด ไม่มีคำสั่งค้าง และผู้ใช้ส่งทิศทางไม่ตรงสัญญาณที่มีผลหรือจำนวนไม่ตรงขั้นตอนคงที่ปัจจุบันจริง จึงใช้การปฏิเสธและรีเซ็ตสิ้นสุดลำดับเก่า ต้องแสดงเหตุผล ลำดับที่ได้รับผลกระทบ และการดำเนินการถัดไป พร้อมเก็บประวัติ หลังรีเซ็ต ครั้งถัดไปสร้างลำดับใหม่จากรายการที่ 1 ไม่สามารถต่อคำสั่งขาดทุนลำดับเก่ากับลำดับใหม่เพื่อคำนวณแพ้ 8 ครั้งติด กำไรขาดทุนที่เสร็จในลำดับเก่ายังคงอยู่ ไม่ได้รับชดเชย 90% อัตโนมัติ แต่ไม่กระทบสิทธิ์ขอตรวจสอบใหม่เรื่องข้อผิดพลาดแพลตฟอร์ม รีเซ็ตผิด หรือข้อพิพาทอื่น\n4.6 คำขอฝ่าฝืนที่ถูกปฏิเสธไม่ถือเป็นธุรกรรม ไม่สร้างการสูญเสียเงินต้น ค่าเบี้ยประกัน หรือโหนดขาดทุนใหม่ การแสดงในเอกสารต้นฉบับเรื่องแปลงขาดทุนฝ่าฝืนเป็นโหนดยังไม่เป็นกฎที่บังคับใช้ ไม่สามารถสร้างขาดทุนหรือชดเชยปลอมสำหรับคำสั่งที่ปฏิเสธ\n4.7 ผู้ใช้หยุดเริ่มขั้นตอนถัดไปไม่เท่ากับเกิดแพ้ 8 ครั้งติด ลำดับที่ไม่เสร็จไม่สามารถขอชดเชย 90% ตามสัดส่วนจำนวนที่ขาดทุน การสิ้นสุดลำดับโดยสมัครใจ การอยู่ระยะยาว และกำหนดการกู้คืนต้องยืนยันกฎอย่างเป็นทางการ ห้ามเพิ่มเวลาหมดอายุที่ไม่เปิดเผยเอง การออกปกติและขาดการเชื่อมต่อไม่ตีความว่าสละสิทธิ์โดยสมัครใจ ลำดับเดียวกันต้องปฏิบัติครบสี่เงื่อนไขพร้อมกันจึงคำนวณชดเชย JOULE 90% ตามการออกแบบปัจจุบัน: แต่ละรายการกลไกประกันเปิดมีผลและเงินต้นพร้อมค่าเบี้ยแช่แข็งสำเร็จจริง แต่ละรายการทิศทางตรงสัญญาณ AI ที่มีผลเมื่อรับ แต่ละรายการเงินต้นและลำดับขั้นตรงแผนที่ยืนยัน 8 รายการชำระครบและผลเป็นขาดทุนที่มีคุณสมบัติทั้งหมด จำนวนชดเชยคือเงินต้นรวม 8 รายการที่มีคุณสมบัติคูณ 90% วัดและจ่ายด้วย JOULE ค่าเบี้ยไม่รวมในฐาน 90% นั้น ชดเชยไม่สามารถแสดงตรงๆ ว่าคืน 90% ของค่าใช้จ่ายทั้งหมด และไม่แปลงเป็น USDT เงินสด หรือ PANTA อัตโนมัติ การแลกสินทรัพย์อื่นยังต้องมีกฎและอนุญาตแยก\n4.8 การมีคุณสมบัติชดเชยและการชำระสำเร็จเป็นสองขั้นตอน หากมีคุณสมบัติแต่เงินไม่พอ บัญชีผิดปกติ หรือมีข้อจำกัด ให้คงหน้าที่และรายละเอียดรอชำระ แสดงกำลังดำเนินการหรือเหตุผลระงับชัดเจน แล้วดำเนินการตามกฎหมายและสัญญา ห้ามเขียนทับความยากในการชำระเป็นผู้ใช้ไม่มีคุณสมบัติ\n4.9 ชดเชยดำเนินการครั้งเดียวตามบันทึกเดียวของลำดับนั้น ชำระสำเร็จแต่สูญการตอบกลับ การสอบถามและลองใหม่ภายหลังต้องคืนผลเดิม ไม่ชำระซ้ำ ชำระล้มเหลวต้องคงสถานะไม่เสร็จจริง ห้ามบังคับผู้ใช้สร้างลำดับใหม่หรือสั่งซื้อใหม่เพื่อ「เปิดใช้」ชดเชยเดิม หากลำดับเดียวกันอนุญาตอัตราต่างกันตามกลไกยืนยันล่วงหน้า ต้องเก็บสแนปช็อตแต่ละรายการและสะสมค่าใช้จ่ายจริง ห้ามใช้อัตราปัจจุบันเดียวคำนวณคำสั่งในอดีตทั้งหมด การเปลี่ยนกลไกอัตราที่กระทบลำดับที่ยืนยันแล้วต้องชี้ขอบเขตก่อน ห้ามเพิ่มต้นทุนย้อนหลังผ่านหน้าใหม่\n4.10 หน่วยขั้นต่ำสินทรัพย์ ความแม่นยำ วิธีปัดเศษต่อรายการ และการจัดการเศษต้องกำหนดก่อนเผยแพร่และคงที่ การปัดเศษบนหน้าเพื่ออ่านง่ายห้ามเปลี่ยนรายละเอียดบัญชี ความแม่นยำในตัวอย่างคำนวณไม่ใช่ความแม่นยำการชำระที่อนุมัติแล้ว ค่าธรรมเนียม ส่วนต่างราคา และเศษห้ามซ่อนด้วยการแสดงรวม\n\nข้อ 5: บริการระบบ\n\n5.1 ขาดการเชื่อมต่อหรือคำขอหมดเวลา: ผู้ใช้สอบถามคำสั่งเดิมก่อน แพลตฟอร์มส่งคืนสถานะจริงที่รับแล้ว ปฏิเสธชัดเจน หรือยังรอยืนยัน เมื่อผลเดิมไม่ทราบ ห้ามชักจูงชำระซ้ำ ยืนยันภายหลังว่าไม่รับแล้วจึงยืนยันคำขอใหม่ตามกฎที่มีผลปัจจุบัน\n5.2 สัญญาณหรือราคาเสนอหมดอายุ: ปฏิเสธคำขอเก่า แสดงเหตุผลและดึงเนื้อหาใหม่ ห้ามแทนที่เงียบๆ ด้วยทิศทาง จำนวน หรือค่าใช้จ่ายใหม่ หรือถือหมดอายุเป็นรีเซ็ตฝ่าฝืน AI อัตโนมัติ หากคำขอเก่ารับแล้ว ยังดำเนินการตามสแนปช็อตนั้น\n5.3 ผลหรือราคาผิดปกติ: หยุดการตัดสิน การประเมิน หรือการจัดสรรที่ได้รับผลกระทบ ให้สถานะ ขอบเขตผลกระทบ และช่องทางสอบถาม ผลหายไม่สามารถบันทึกเป็นขาดทุนล้มเหลว การประเมินผิดปกติไม่ใช้ขยายฐานขาดทุน การเปลี่ยนแหล่งสำรองต้องตามลำดับแหล่งและกฎผิดปกติที่ประกาศล่วงหน้า\n5.4 ความต่างบัญชีหรือสถานะธุรกรรมภายนอกไม่ทราบ: ตรวจสอบบันทึกเดิมและใบเสร็จภายนอกก่อน ไม่ส่งการกระทำที่ไม่ย้อนกลับซ้ำ หลังยืนยันล้มเหลว ปลดแช่หรือลองใหม่ตามกฎที่เกี่ยวข้อง ไม่ทราบไม่เท่ากับคืนเงินแล้ว การดำเนินการเงินผู้ใช้ที่เสร็จและขั้นซื้อเหรียญ ฝากพูลที่ยังไม่เสร็จต้องแสดงแยก\n5.5 เงินไม่พอ: หยุดธุรกิจใหม่ที่อาจขยายช่องว่าง คงหน้าที่ที่เกิดแล้ว แจ้งสถานะรอดำเนินการ และดำเนินการตามแผนที่อนุมัติ ห้ามปลอมว่าเงินเข้า เปลี่ยนยอดใช้ได้เป็นติดลบ หรือเติมช่องว่างด้วยค่าใช้จ่ายเพิ่มที่ไม่แจ้ง\n5.6 จำกัดความเสี่ยง: แพลตฟอร์มสามารถตรวจสอบหรือจำกัดตามกฎที่อนุมัติและเปิดเผยอย่างเหมาะสม แต่ต้องแยกจำกัดคำสั่งใหม่ หน่วงชำระ และยกเลิกคุณสมบัติ การจำกัดห้ามเขียนทับชนะแพ้ในอดีตหรือเงื่อนไขเศรษฐกิจที่ครบแล้ว ข้อยกเว้นต้องมีข้อเท็จจริงและหลักฐาน พร้อมช่องทางตรวจสอบใหม่\n5.7 เมื่อบำรุงรักษา หยุดบริการ หรือปิดผลิตภัณฑ์ คำสั่งในอดีต การชดเชย ข้อพิพาท และบันทึกที่ตรวจสอบได้ยังต้องมีแผนดำเนินการ ผู้ใช้ไม่สามารถเพิ่มธุรกรรมใหม่ไม่หมายความว่ายอดคงเหลือ การชดเชยที่ต้องจ่าย หรือสิทธิ์อุทธรณ์หายไป ปิดสวิตช์ธุรกิจใหม่ห้ามปิดการสอบถามและดำเนินการในอดีตทั้งหมดด้วย\n\nข้อ 6: ข้อจำกัดความรับผิด\n\nกรณีต่อไปนี้ที่ทำให้ขาดทุน บริการไม่รับผิดชอบชดเชย\n6.1 ผู้ใช้ไม่ปฏิบัติตามกลยุทธ์: พฤติกรรมใดที่เบี่ยงเบนจากกฎการจัดการตำแหน่งมาตรฐานของแพลตฟอร์มนี้\n6.2 สภาวะตลาดสุดขั้ว: ขาดทุนจากตลาดหยุดชะงัก สภาพคล่องหมด การจัดการตลาด\n6.3 ความเสี่ยงระบบและการดำเนินงาน: ขาดทุนจากอุปกรณ์ผู้ใช้เสีย ความผิดพลาดในการใช้งาน บัญชีถูกขโมย\n6.4 ความเสี่ยงนโยบายและการปฏิบัติตาม: การหยุดหรือห้ามธุรกรรมจากการเปลี่ยนกฎหมาย ระเบียบ หรือคำสั่งกำกับดูแล\n6.5 ความเสี่ยงโทเค็นภายใน: มูลค่าตลาด JOULE ร่วงหรือล่มสลาย กระทบหน้าที่เป็นหลักประกันและสกุลเงินชำระ\n6.6 การฉ้อโกงและพฤติกรรมมุ่งร้าย: ผู้ใช้เกี่ยวข้องการฉ้อโกง ฟอกเงิน จัดการตลาด หรือกิจกรรมผิดกฎหมายอื่น\n6.7 เหตุสุดวิสัย: ความขัดข้องระบบแพลตฟอร์มนี้จากเหตุสุดวิสัย\n\nข้อ 7: การเปิดเผยความเสี่ยง\n\nผู้ใช้ยืนยันว่าเข้าใจและยอมรับความเสี่ยงต่อไปนี้อย่างเพียงพอ:\n7.1 ไม่รับประกันเงินต้นและกำไร: แผนนี้ชดเชยเฉพาะขาดทุนบางส่วน ไม่รับประกันความปลอดภัยเงินต้นหรือกำไรอย่างแน่นอน\n7.2 ความเสี่ยงพึ่งพากลยุทธ์: ผลการคุ้มครองขึ้นอยู่กับการปฏิบัติตามกลยุทธ์อย่างเคร่งครัดทั้งหมด\n7.3 ความเสี่ยงสภาพคล่องและการล็อก: เงินชดเชยเข้าบัญชีจัดการความมั่งคั่งอาจมีความเสี่ยงการลงทุนและระยะเวลาล็อก กระทบสภาพคล่อง\n7.4 ความเสี่ยงบุคคลที่สาม: ตลาดที่พึ่งพามีความเสี่ยงการดำเนินงาน ความปลอดภัย และความผันผวนมูลค่า\n7.5 ความไม่แน่นอนด้านกำกับดูแล: แพลตฟอร์มนี้เผชิญความไม่แน่นอนกำกับดูแลทั่วโลกและความเสี่ยงถูกหยุด\n7.6 ความเสี่ยงด้านความปลอดภัยทางเทคนิค: รวมความเสี่ยงสูญเสียสินทรัพย์จากช่องโหว่ smart contract การแฮ็ก ฯลฯ\n\nข้อ 8: การเปลี่ยนแปลง การสิ้นสุด และข้อพิพาท\n\n8.1 การเปลี่ยนแปลงข้อตกลง: แพลตฟอร์มนี้สงวนสิทธิ์แก้ไขข้อตกลงตามกฎหมายหรือความจำเป็นในการดำเนินงาน การเปลี่ยนแปลงสำคัญจะแจ้งผ่านประกาศแพลตฟอร์ม\n8.2 การสิ้นสุดข้อตกลง: ผู้ใช้สามารถปิดสวิตช์คุ้มครองเมื่อใดก็ได้เพื่อสิ้นสุดบริการ หากผู้ใช้ละเมิดข้อตกลง แพลตฟอร์มสามารถสิ้นสุดฝ่ายเดียว ด้วยเหตุผลกฎหมายหรือนโยบาย แผนนี้อาจสิ้นสุด\n8.3 การแก้ไขข้อพิพาท: ข้อพิพาทจากข้อตกลงนี้ควรแก้ด้วยการเจรจาโดยสุจริต หากไม่สำเร็จ จะส่งต่อหน่วยงานอนุญาโตตุลาการหรือศาลที่กำหนด\n\n【ยืนยันขั้นสุดท้าย】ท่านเข้าใจและตกลงว่า「เปิดใช้สวิตช์ประกันภัย」เป็นวิธีเดียวและขั้นสุดท้ายในการยืนยันว่าท่านผูกพันตามเนื้อหาข้อตกลงทั้งหมดนี้ โปรดตัดสินใจด้วยการพิจารณาอย่างเป็นอิสระ",
    lockedBalance: "Non-transferable",
    equityTitle: "Event insurance equity",
    personalEquity: "Personal equity",
    teamEquity: "Team equity",
    equityNodes: "Active nodes",
    remainingEquity: "Remaining equity",
    peersPaid: "Peer paid",
    peersPending: "Peer pending",
    creditsCount: "Credit rows",
    nodeBatches: "Node batches",
    peerRows: "Pending peer rows",
    recentPayouts: "Recent payouts",
    premiumRules: "Position threshold {threshold}% · low premium {low}% · high premium {high}% (preview wins per order)",
    insuranceDeduction: "Insurance premium deduction (Event)",
    insurancePayout: "Insurance premium payout (Event)"
  },
  walletBind: {
    connectWallet: "เชื่อมต่อ",
    inputPlaceholder: "ป้อนที่อยู่",
    bind: "ผูก",
    binding: "กำลังผูก",
    tip: "เคล็ดลับ: หากการเชื่อมต่อกระเป๋าเงินล้มเหลว คุณสามารถลองป้อนที่อยู่กระเป๋าเงินด้วยตนเองเพื่อผูก"
  },
  loginModal: {
    title: "เข้าสู่ระบบ PANTA MARKET",
    connectWallet: "เชื่อมต่อ",
    connecting: "กำลังเชื่อมต่อ...",
    alreadyConnected: "เชื่อมต่อแล้ว",
    tip: "เคล็ดลับ: หากการเชื่อมต่อกระเป๋าเงินล้มเหลว คุณสามารถลองป้อนที่อยู่กระเป๋าเงินด้วยตนเองเพื่อผูก",
    inputLabel: "ป้อนที่อยู่กระเป๋าเงิน",
    inputPlaceholder: "0x234d456f6798...",
    bind: "ผูก",
    binding: "กำลังผูก",
    bindSuccess: "ผูกสำเร็จ",
    bindSuccessHint: "ผูกสำเร็จ กรุณาเข้าสู่ระบบอีกครั้ง",
    bindFailed: "ผูกล้มเหลว",
    noAuthCode: "ขาดรหัสอนุญาต",
    invalidAddress: "รูปแบบที่อยู่กระเป๋าเงินไม่ถูกต้อง",
    confirmTitle: "ยืนยันการผูก",
    confirmWarning: "โปรดยืนยันอย่างระมัดระวังว่าที่อยู่ต่อไปนี้เป็นที่อยู่กระเป๋าเงินของคุณ ไม่สามารถเปลี่ยนแปลงได้หลังจากผูก",
    addressLabel: "ที่อยู่กระเป๋าเงิน",
    cancel: "ยกเลิก",
    confirm: "ยืนยันการผูก",
    loginSuccess: "เข้าสู่ระบบสำเร็จ",
    openWalletApp: "เปิด {wallet}",
    openWalletConnect: "เปิด {wallet} เพื่อเชื่อมต่อ",
    openWalletSign: "เปิด {wallet} เพื่อลงนาม",
    returnToBrowser: "กลับมาที่นี่เมื่อเสร็จแล้ว",
    loginStepLabel: "ขั้นตอน {step}/2",
    stepConnectTitle: "เชื่อมต่อกระเป๋า",
    stepConnectHint: "อนุมัติการเชื่อมต่อในกระเป๋า แล้วกลับมาที่นี่",
    stepConnectHintWithOpen: "แตะด้านล่างเพื่อเปิดกระเป๋า อนุมัติการเชื่อมต่อ แล้วกลับมา",
    stepSignTitle: "ลงชื่อเข้าใช้",
    stepSignHint: "ลงนามข้อความเข้าสู่ระบบในกระเป๋า (ไม่มีการโอนสินทรัพย์) แล้วกลับมาที่นี่",
    stepSignHintWithOpen: "อีกหนึ่งขั้นตอน: แตะด้านล่างเพื่อเปิดกระเป๋าและลงนามข้อความเข้าสู่ระบบ",
    waitingWalletHintShort: "หากไม่เปิดอัตโนมัติ แตะด้านล่างเพื่อเปิดกระเป๋า",
    retryLogin: "ลองเข้าสู่ระบบอีกครั้ง",
    networkRequired: "เปลี่ยนเครือข่าย",
    networkRequiredHint: "เปลี่ยนเป็น {chain} แล้วกลับมาที่นี่และลองใหม่",
    switchingNetwork: "ยืนยันการเปลี่ยนเครือข่าย",
    switchingNetworkHint: "อนุมัติการเปลี่ยนเป็น {chain} ในกระเป๋าของคุณ",
    signatureRequired: "ลงนามเพื่อเข้าสู่ระบบ",
    signatureHint: "ลงนามในกระเป๋า — จะไม่มีการโอนเงิน",
    verifyingLogin: "กำลังตรวจสอบ",
    verifyingHint: "โปรดรอสักครู่",
    connectFailed: "การเชื่อมต่อไม่สมบูรณ์ กรุณาลองใหม่",

    waitingWalletReturn: "อนุมัติในแอปกระเป๋าแล้วกลับมาที่หน้านี้",
    waitingWalletHint: "อนุมัติในกระเป๋า แล้วระบบจะพากลับมาที่นี่"
  },
  walletProfile: {
    title: "โปรไฟล์",
    address: "ที่อยู่",
    accountName: "ชื่อบัญชี",
    inviteCode: "รหัสเชิญ",
    deactivateAccount: "ปิดใช้งานบัญชี",
    logout: "ออกจากระบบ",
    switchAccount: "สลับบัญชี",
    confirmLogout: "คุณแน่ใจหรือไม่ว่าต้องการออกจากระบบ?",
    loggingOut: "กำลังออกจากระบบ...",
    confirmSwitch: "คุณแน่ใจหรือไม่ว่าต้องการสลับบัญชี? บัญชีปัจจุบันจะออกจากระบบ",
    developing: "กำลังพัฒนา",
    addressCopied: "คัดลอกที่อยู่แล้ว",
    inviteCodeCopied: "คัดลอกรหัสเชิญแล้ว"
  },
  aiPrediction: {
    stakeAutofill: "ผู้ช่วย AI",
    stakeAutofillWarning: "เป็นเพียงตัวช่วย ยอดที่แนะนำอาจผิดพลาด กรุณาตรวจสอบก่อนสั่ง ระบบจะหยุดเติมอัตโนมัติเมื่อดีเลย์เกิน 800ms หรือตรวจสอบการเชื่อมต่อล้มเหลว/หมดอายุ และจะทำงานต่อเมื่อกลับมาปกติ ไม่กระทบการสั่งด้วยตนเอง",
    stakeAutofillUnavailable: "การเชื่อมต่อไม่เสถียรหรือดีเลย์เกิน 800ms ยังเปิดไม่ได้",
    stakeAutofillPaused: "หยุดเติมอัตโนมัติชั่วคราว: การเชื่อมต่อไม่เสถียร กรุณากรอกจำนวนเอง",
    insuranceSyncing: "กำลังซิงค์ขั้นตอนประกัน…",
    predictionBuffer: 'กำลังเตรียมการคาดการณ์ถัดไป',
    scheduleResultPending: 'ผลรอบนี้ยังไม่พร้อม กำลังลองอีกครั้ง',
    title: "การทำนาย AI",
    bookingTitle: "จองรอบ AI",
    bookingExpand: "ขยาย",
    bookingCollapse: "ย่อ",
    bookingNextSystem: "รอบถัดไปของระบบ · SGT",
    bookingNextMine: "การจองถัดไปของฉัน",
    bookingNone: "ไม่มี",
    bookingStartingSoon: "รอบที่จองไว้กำลังจะเริ่ม",
    bookingToday: "วันนี้",
    bookingTomorrow: "พรุ่งนี้",
    bookingTimezone: "SGT",
    bookingQuota: "เหลือเข้าร่วม {remaining}/{dailyLimit} รอบ",
    bookingSeats: "{occupied}/{capacity} ที่นั่ง",
    bookingEmpty: "ไม่มีรอบว่าง",
    bookingWaiting: "จะเข้าอัตโนมัติเมื่องานปัจจุบันเสร็จ",
    bookingEnded: "สิ้นสุดแล้ว",
    bookingJoin: "เข้าร่วมรอบนี้",
    bookingReserve: "จอง",
    bookingJoined: "เข้าแล้ว",
    bookingReserved: "จองแล้ว",
    bookingFull: "เต็ม",
    bookingConfirm: "ยืนยันการจอง",
    bookingWarning: "จองสำเร็จจะใช้สิทธิ์ 1 ครั้งของวันนั้น แม้ไม่เข้าร่วมก็ถูกนับ",
    bookingQuotaExhausted: "ใช้สิทธิ์เข้าร่วมของวันนี้ครบแล้ว",
    bookingUnavailable: "จองไม่ได้ในตอนนี้",
    bookingFailed: "จองไม่สำเร็จ กรุณารีเฟรชแล้วลองใหม่",
    aiPool: "กองทุน AI",
    countdown: "นับถอยหลัง",
    expectedProfit: "กำไรที่คาดหวัง",
    active: "ใช้งานอยู่",
    aiAnalysis: "การวิเคราะห์ความน่าจะเป็นขึ้น/ลงอัจฉริยะ AI",
    updateTime: "เวลาอัปเดต",
    probabilityUp: "ความน่าจะเป็นขาขึ้น",
    probabilityDown: "ความน่าจะเป็นขาลง",
    startPrediction: "เริ่มทำนาย",
    predicting: "กำลังทำนาย...",
    stayOnPageHint: "โปรดอย่าออกจากหน้านี้ มิฉะนั้นผลการทำนายอาจสูญหาย",
    userInfo: "ข้อมูลผู้ใช้",
    predictCount: "จำนวนการทำนาย",
    freeCount: "การทำนายฟรี",
    openTime: "เปิดเวลา: {time1}",
    up: "ขึ้น",
    down: "ลง",
    notConnected: "ไม่ได้เชื่อมต่อ",
    count: "จำนวน",
    learnMore: "เรียนรู้เพิ่มเติม",
    calculating: "กำลังคำนวณ...",
    settled: "ชำระแล้ว",
    loginFirst: "กรุณาเข้าสู่ระบบก่อน",
    sessionSyncing: "กำลังซิงค์",
    actions: {
      rise: "ลอง",
      fall: "ชอร์ต"
    },
    holdings: {
      current: "ตำแหน่ง",
      history: "ประวัติ",
      empty: "ไม่มีตำแหน่ง",
      historyEmpty: "ไม่มีประวัติ",
      aiHistory: "AI History",
      aiHistoryEmpty: "No AI history"
    },
    buyModal: {
      title: "ซื้อสิทธิพิเศษ",
      description: "ซื้อการทำนาย AI 30 ครั้ง",
      upgradeAmount: "จำนวนอัปเกรด",
      balance: "ยอดเงินที่ใช้ได้",
      cancel: "Cancel",
      confirm: "ยืนยัน",
      purchasing: "กำลังซื้อ...",
      purchaseSuccess: "ซื้อสำเร็จ",
      purchaseFailed: "ซื้อล้มเหลว",
      dailyLimit: "You can purchase once per day."
    },
    noPredictionAlert: {
      title: "การทำนาย AI เริ่มล้มเหลว",
      description: "จำนวนการทำนาย AI ของคุณเป็น 0 คุณไม่สามารถใช้ฟังก์ชันการทำนาย AI ได้ในขณะนี้ กรุณาซื้อเพื่อดำเนินการต่อ",
      cancel: "ยกเลิก",
      confirm: "ซื้อการทำนาย AI"
    },
    toasts: {
      predictionFailed: "ทำนายล้มเหลว",
      predictionSuccess: "ทำนายสำเร็จ",
      premiumShortfallReminder: "Full-round premium shortfall ~{amount} JOULE (reminder only; this order can still submit)",
      deferredWaitSettlement: "Signal ready; wait for the open position to settle before placing",
      insuranceTierUnavailable: "Insurance tier unavailable; try again later",
      insuranceCancelFailed: "Cannot close; unsettled orders may exist",
      resumeFailed: "Failed to resume prediction; try again later",
      requiredStakeInvalid: "Invalid prediction stake; start AI prediction again"
    },
    analyzing: "กำลังวิเคราะห์...",
    insurance: "ประกัน",
    insuranceOn: "มีผล",
    insuranceOff: "ยังไม่มีผล",
    aiLabel: "AI",
    lookLong: "ขาขึ้น",
    lookShort: "ขาลง",
    waitingResult: "Waiting",
    startAIPrediction: "Start AI Prediction",
    scheduleConfirm: "ตามรอบนี้",
    scheduleBinding: "กำลังผูกสัญญาณ...",
    predictionResult: "AI Prediction Result",
    nextRound: "Next Round",
    rise: "Long",
    fall: "Short",
    openPrice: "ราคาเปิด",
    settledAt: "ชำระเมื่อ",
    ordinaryInsuranceTitle: "ออเดอร์นี้เป็นประกันทั่วไป",
    ordinaryInsuranceBody: "ออเดอร์นี้เป็นประกันทั่วไป ไม่ใช่การจ่ายรอบ AI หลังยืนยันจะส่งตามเบี้ยที่พรีวิว",
    sessionConflict: "ยังมีรอบประกัน AI ที่ดำเนินอยู่ กรุณากู้คืนหรือจบรอบก่อนทำประกันทั่วไป",
    conversionTitle: "แปลงเป็นประกันธรรมดา?",
    conversionDesc: "ออเดอร์นี้จะแปลงเป็นประกันธรรมดาและจบรอบประกัน AI ขาดทุน AI ต่อเนื่องก่อนหน้าจะไม่ชดเชย พรีเมียมธรรมดา {premium} JOULE",
    conversionConfirm: "ยืนยันแปลงและสั่ง",
    stakeFromStrategy: "ขนาดกำหนดโดยกลยุทธ์",
    stakeTier: "ระดับ {tier}",
    stakeStep: "ขั้น {step}",
    selfQuotaRemaining: "ครั้งทำนายเองคงเหลือ: {remaining}/{limit}",
    followRoundProgress: "ตาม AI · รอบ {current}/{total}",
    followRoundsCompleted: "ตาม AI เสร็จสิ้น · {current}/{total}",
    selfQuotaLoadingShort: "กำลังโหลดโควตา…",
    selfQuotaLoginHint: "เข้าสู่ระบบเพื่อดูโควตา",
    selfQuotaLoading: "กำลังโหลดโควตา ลองใหม่ภายหลัง",
    selfQuotaExhausted: "โควตาทำนายเองฟรีวันนี้หมดแล้ว การทำนายแบบเสียเงินยังไม่เปิด"
  },
  positionModal: {
    title: "การคาดการณ์ราคา",
    insurance: "ประกัน",
    long: "Long",
    short: "Short",
    balance: "ยอดคงเหลือ",
    loading: "กำลังโหลด...",
    confirm: "ยืนยัน",
    processing: "กำลังประมวลผลคำสั่ง...",
    success: "สั่งซื้อสำเร็จ!",
    insuranceOn: "เปิดใช้งานประกันแล้ว",
    insuranceOff: "ปิดใช้งานประกันแล้ว",
    operationFailed: "การดำเนินการล้มเหลว",
    balanceFetchFailed: "ไม่สามารถดึงยอดคงเหลือ",
    minAmount: "จำนวนขั้นต่ำคือ 0.1 TAKER",
    insufficientBalance: "ยอดคงเหลือไม่เพียงพอ ยอดคงเหลือปัจจุบัน: {balance} TAKER",
    createFailed: "ไม่สามารถสร้างตำแหน่ง",
    recoverTitle: "Recover pending order",
    recoverContent: "Unconfirmed order found ({symbol} {direction} {amount}). Will reuse the original idempotency key without requoting.",
    recoverConfirm: "Recover",
    recoverCancel: "Cancel"
  },

  appeal: {
    title: "ความช่วยเหลือในการตรวจสอบสินทรัพย์",
    records: "บันทึกการส่ง",
    recordsTitle: "บันทึกการส่ง",
    noRecords: "ไม่มีบันทึกการส่ง",
    submitTime: "เวลาส่ง",
    statusPending: "รอดำเนินการ",
    statusApproved: "อนุมัติ",
    statusRejected: "ปฏิเสธ",
    failedReason: "เหตุผลการปฏิเสธ",
    uniLiveUid: "UniLive ID",
    uniLiveUidLoading: "กำลังโหลด...",
    walletAddress: "ที่อยู่ที่ผูกกับ PANTA MARKET",
    address: "ที่อยู่",
    walletAddressPlaceholder: "ป้อนที่อยู่เข้าสู่ระบบ PANTA MARKET",
    autoFill: "กรอกอัตโนมัติ",
    depositAmount: "จำนวนเงินฝาก",
    depositAmountPlaceholder: "ป้อนจำนวนเงินฝาก",
    tokenType: "ประเภทโทเค็น",
    selectToken: "เลือกโทเค็น",
    tokens: {
      usdt: "USDT",
      taker: "JOULE"
    },
    transferTime: "เวลาโอน",
    selectTime: "เลือกเวลาโอน",
    timeRangeHint: "ข้อมูลที่เกี่ยวข้องที่เกิดขึ้นระหว่างวันที่ 5 มีนาคม 2026 เวลา 00:00 ถึง 11 มีนาคม เวลา 10:00 (SGT)",
    txHash: "HASH / TXID",
    txHashPlaceholder: "ป้อนแฮชธุรกรรม",
    txHashHint: "สามารถตรวจสอบได้ในเบราว์เซอร์บล็อกเชน",
    uploadImages: "ภาพหน้าจอบันทึกการโอน",
    uploadHint: "ไม่บังคับ อัปโหลดได้สูงสุด 9 รูป",
    addImage: "เพิ่มรูปภาพ",
    submit: "ส่ง",
    submitting: "กำลังส่ง...",
    submitSuccess: "ส่งสำเร็จ",
    submitFailed: "การส่งล้มเหลว โปรดลองอีกครั้ง",
    uploadingImages: "กำลังอัปโหลดรูปภาพ...",
    uploadImagesFailed: "อัปโหลดรูปภาพล้มเหลว",
    warningTitle: "ประกาศสำคัญ",
    warningText: "หากบันทึกที่ส่งได้รับการตรวจสอบสำเร็จ คุณจะได้รับรางวัล 5% ของพลังการสมัครสมาชิก หากให้ข้อมูลเท็จ บัญชีจะถูกระงับ"
  },
  withdrawSheet: {
    title: "ถอน",
    balance: "ยอดคงเหลือ",
    processing: "กำลังถอน TAKER...",
    success: "ถอน TAKER สำเร็จ!",
    withdrawing: " กำลังถอน...",
    withdrawSuccess: " ส่งรอการตรวจสอบแล้ว",
    recordBadge: "Withdraw Record",
    sheetTitle: "Withdraw {token}",
    sheetDesc: "Enter the amount to withdraw. Minimum {min} USDT. No fees.",
    available: "Available {token}",
    amountPlaceholder: "Enter amount (min {min} USDT)"
  },
  depositSheet: {
    title: "ฝาก TAKER",
    depositTo: "ฝากเข้า",
    spotAccount: "บัญชีสปอต",
    network: "เครือข่าย",
    networkWarning: "รองรับเฉพาะการฝากผ่านเครือข่าย BSC/BEP20 เท่านั้น การสูญเสียสินทรัพย์จากการใช้เครือข่ายอื่นไม่สามารถกู้คืนได้",
    depositAddress: "ที่อยู่ฝาก",
    address: "ที่อยู่",
    depositTAKER: "ฝาก TAKER",
    recharge: "เติมเงิน",
    rechargeAddress: "ที่อยู่เติมเงิน",
    copy: "คัดลอก",
    copySuccess: "คัดลอกสำเร็จ",
    loadingAddress: "กำลังรับที่อยู่เติมเงิน...",
    loadAddressFailed: "ไม่สามารถรับที่อยู่เติมเงิน",
    clickToRetry: "คลิกเพื่อลองอีกครั้ง",
    saveAndShare: "บันทึกและแชร์ที่อยู่",
    generating: "กำลังสร้าง...",
    generateSuccess: "สร้างสำเร็จ",
    generateFailed: "สร้างล้มเหลว",
    more: "เพิ่มเติม",
    save: "บันทึก",
    wechat: "WeChat",
    recordBadge: "Deposit Record",
    sheetDesc: "Deposit {token} from your wallet to platform balance",
    telegram: "Telegram",
    discord: "Discord",
    x: "X",
    savedImage: "รูปภาพที่บันทึก",
    download: "ดาวน์โหลด",
    pleaseGenerate: "กรุณาสร้างรูปภาพก่อน",
    downloadSuccess: "ดาวน์โหลดสำเร็จ",
    saveSuccess: "บันทึกสำเร็จ",
    saveFailed: "บันทึกล้มเหลว",
    needPermission: "ต้องการสิทธิ์ในการบันทึกรูปภาพลงในอัลบั้ม",
    pleaseUseDapp: "กรุณาใช้กระเป๋าเงินเพื่อเปิดการดำเนินการ dapp",
    claimDesc: "Transfer USDT to the deposit address, then paste the tx hash to claim",
    claimButton: "Claim Deposit",
    environment: "Environment",
    txHash: "Transaction Hash",
    txHashPlaceholder: "Paste 0x transaction hash",
    optionalAmount: "Amount (optional note)"
  },
  sidebar: {
    loginAccount: "เข้าสู่ระบบบัญชี",
    inviteBanner: "เชิญเพื่อนและรับค่าคอมมิชชั่นทีม",
    inviteCode: "รหัสเชิญ",
    defaultName: "PANTA MARKET",
    logoutWallet: "Disconnect Wallet"
  },
  teamDetails: {
    myReferrals: "การแนะนำของฉัน",
    currentLevel: "ระดับปัจจุบัน: {level}",
    nextLevel: "ระดับถัดไป",
    totalMembers: "การอ้างอิงโดยตรง",
    validMembers: "สมาชิกที่ถูกต้อง",
    teamLevel: "ระดับทีม: {level}",
    tradeTeam: "ทีมเทรด",
    financeTeam: "ทีมการเงิน",
    teamMembers: "สมาชิกทีม",
    teamData: "Team Data",
    teamEarningsJoule: "Team Earnings (WATT)",
    myCurrentLevel: "My level: {level}",
    currentTotalPerf: "Total performance: {value}",
    currentAreaPerf: "Area performance: {value}",
    inviteDetails: "Invite details",
    startDate: "Start date",
    dateTo: "to",
    endDate: "End date",
    editRemark: "Edit note",
    addRemark: "Add note",
    viewDetail: "View details",
    status: "Status: ",
    time: "Time: ",
    level: "Level: ",
    inviteType: "Invite type: ",
    viewTeam: "View team",
    communityValidCount: "Community actives: ",
    communityTotalPerf: "Community volume: ",
    areaTotalPerf: "Area volume: ",
    yesterdayStake: "Yesterday stake: ",
    communityMaxLevel: "Community top level: ",
    personalEquity: "Personal equity: ",
    remarkPlaceholder: "Enter a note",
    saveRemark: "Update",
    filterAll: "All",
    filterDirect: "Direct",
    filterIndirect: "Indirect",
    viewingIndirect: "สายตรงของ {name}",
    teamPowerUsdt: "Team Power (USDT)",
    teamFlowJoule: "Team Volume (WATT)",
    statusInvalid: "Inactive",
    statusValid: "Active",
    peopleUnit: "{n}",
    remarkSaved: "Note saved"
  },
  teamMemberModal: {
    totalProfit: "กำไรรวม",
    totalFlow: "ปริมาณรวม",
    totalInvites: "จำนวนการเชิญทั้งหมด",
    validMembers: "จำนวนสมาชิกที่ถูกต้องทั้งหมด"
  },
  fundRecords: {
    feeLabel: "Fee: {fee}",
    withdrawTitle: "Withdraw Records",
    exchangeTitle: "Exchange Records",
    depositTitle: "Deposit Records"
  },
  aiAssistant: {
    title: "PANTA MARKET",
    newChat: "แชทใหม่",
    manual: "Manual",
    manualCardTitle: "Open operation manual",
    manualCardDesc: "Illustrated steps for deposit, exchange, transfer, and AI prediction",
    hello: "สวัสดี ฉันคือผู้ช่วย AI",
    hint: "ถามวิเคราะห์ตลาด ที่ดูกฎประกันอีเวนต์/AI ทีมและเชิญ หรือความเสี่ยง",
    placeholder: "ถามอะไรสักอย่าง...",
    send: "ส่ง",
    thinking: "กำลังวิเคราะห์...",
    disclaimer: "เพื่ออ้างอิงเท่านั้น ไม่ใช่คำแนะนำการลงทุน",
    bullish: "ขาขึ้น",
    bearish: "ขาลง",
    aiAnalysis: "สรุป AI",
    strategy: "กลยุทธ์",
    reasoning: "เหตุผล",
    targetPrice: "เป้าหมาย {price}",
    stopLoss: "ตัดขาดทุน {price}",
    takeProfit: "ทำกำไร {price}",
    dirLong: "Long",
    dirShort: "Short",
    dirNeutral: "กลาง",
    analysisDone: "วิเคราะห์ {symbol} ({timeframe}) เสร็จแล้ว ดูการ์ดด้านล่าง",
    analysisBtc: "วิเคราะห์ BTC ระยะสั้น",
    analysisEth: "วิเคราะห์ ETH ในช่วงไซด์เวย์",
    analysisRisk: "สรุปความเสี่ยงตลาด",
    suggestions: {
      btc1m: "วิเคราะห์แนว BTCUSDT 1 นาที",
      ethTrend: "ETH ควรไล่หรือรอดู?",
      marketRisk: "ความเสี่ยงตลาดตอนนี้เป็นอย่างไร?",
      eventRules: "ดูสรุปกฎประกันสัญญาอีเวนต์ที่ไหน?",
      aiRules: "เข้าใจกฎ/ชั้น AI prediction อย่างไร?",
      teamWhere: "ดูรายละเอียดทีมที่ไหน?",
      inviteWhere: "ลิงก์เชิญและผูกสายบนอยู่ที่ไหน?"
    },
    guides: {
      eventRules: "กฎประกันอีเวนต์: เข้าหน้า Event Contract แล้วเปิดทางเข้ากฎข้างสวิตช์ประกัน แท็บสรุปมีเบี้ย/เพดาน/สิทธิ์ชดเชย ส่วนข้อตกลงเต็มเป็นข้อความทางการ",
      aiRules: "AI Prediction: แท็บกลาง → AI Prediction ดูเคานต์ดาวน์รอบถัดไป ชั้น/ขั้นประกัน และจำนวนครั้งทำนายเอง กฎอยู่ในชีตประกันเดียวกัน คำสั่งต้องตรงจำนวนชั้นและทิศทาง",
      teamWhere: "รายละเอียดทีม: แถบข้างหรือฉัน → ทีมของฉัน สลับรายได้เทรด/ไฟแนนซ์ แล้วกดรายละเอียดทีมเพื่อดูสายตรง วอลุ่ม ระดับ และสมาชิก",
      inviteWhere: "เชิญและผูก: แถบข้าง/ฉัน → เชิญเพื่อน เพื่อคัดลอกลิงก์ (?ref=) ถ้ายังไม่ผูกสายบน จะมีป๊อปอัปหลังล็อกอิน หากไม่มีพารามิเตอร์เชิญ ช่องจะเติมที่อยู่ดีฟอลต์ของระบบ"
    },
    generic: {
      a: "รับทราบ ถามตลาด ที่กฎอีเวนต์/AI ทีมและเชิญ หรือกดทางลัดด้านล่าง",
      b: "โอเค จะให้การ์ดแนวโน้มและชี้ทางฟีเจอร์",
      c: "ลองทางลัดกฎอีเวนต์ กฎ AI รายละเอียดทีม หรือลิงก์เชิญ"
    }
  },
  createMarket: {
    title: "Create Market",
    saveDraft: "Save Draft",
    marketTitle: "Market Title",
    titlePlaceholder: "Enter market title",
    category: "Category",
    secondaryOptional: "Secondary (opt.)",
    deadline: "Deadline",
    optionsTitle: "Outcomes (2–16)",
    optionsSub: "Name each option",
    resetDefault: "Reset",
    addOption: "+ Add Option",
    ratioHint: "Initial ratio: leave blank to split evenly; if filled, each option needs an integer 1–99 and the total must be 100.",
    rulesSection: "Rules / Settlement Source",
    rulesSectionSub: "Optional — shown in the rules & settlement popup on the detail page",
    rulesLabel: "Rules",
    rulesPlaceholder: "Settlement criteria, edge cases, etc.",
    settleLabel: "Settlement Source",
    settlePlaceholder: "Official site / news / URL",
    liquidityTitle: "Initial Liquidity",
    liquiditySub: "Funds needed to bootstrap the market",
    enabled: "On",
    disabled: "Off",
    investAmount: "Amount (JOULE)",
    balance: "Balance: {n}",
    max: "Max",
    initialLiquidity: "Initial Liquidity",
    marginRefund: "Margin (refunded after settlement)",
    totalTip: "Margin matches liquidity 1:1 and is fully refunded when the event settles or is canceled.",
    totalDeduct: "Total Deduct",
    feeTip: "Tip: you earn a 0.5% creator fee on every trade in this market.",
    accessPassword: "Access Password",
    accessPasswordSub: "The event will show a lock. Only people with the share link or password can enter.",
    passwordPlaceholder: "Set password (4–20 chars)",
    hide: "Hide",
    show: "Show",
    cardPreview: "Card Preview",
    deadlinePrefix: "Ends {date}",
    submitting: "Creating...",
    submit: "Confirm & Add Liquidity",
    createSuccess: "Created",
    creating: "Creating",
    creatingDesc: "Please wait while we submit the market…",
    backHome: "Home",
    createAnother: "Create Another",
    deadlineShort: "{m}/{d}",
    yes: "Yes",
    no: "No",
    optionN: "Option {n}",
    draftSaved: "Draft saved",
    draftSaveFailed: "Failed to save draft",
    resetDone: "Reset to defaults",
    maxOptions: "Up to 16 options",
    minOptions: "Keep at least 2 options",
    needMinOptions: "Need at least 2 options",
    fillOptionName: "Enter a name for option {n}",
    fillAllPercents: "Fill a ratio for every option",
    percentRange: "Ratios must be integers 1–99",
    percentSum: "Ratios must sum to 100 (now {sum})",
    enterTitle: "Enter a market title",
    enterAmount: "Enter an amount",
    insufficientBalance: "Insufficient balance (incl. margin)",
    passwordLength: "Password must be 4–20 characters",
    deadlineFuture: "Deadline must be in the future",
    completeForm: "Please complete the form",
    createdMsg: "“{title}” created. Ends {date} {time}"
  },
  marketDetail: {
    tabTrades: "ดีลล่าสุด",
    tabLp: "LP",
    tabPositions: "โพซิชัน",
    tabRules: "กฎ",
    colAddress: "ที่อยู่",
    colTime: "เวลา",
    colType: "ประเภท",
    colVolumePrice: "ปริมาณ/ราคา",
    colTurnover: "มูลค่า",
    typeBuy: "ซื้อ",
    typeSell: "ขาย",
    empty: "ไม่มีข้อมูล",
    share: "แชร์",
    rulesBody: "ตลาดนี้เป็นการทำนายเหตุการณ์แบบทวิภาค อาจล็อกสมุดคำสั่งก่อนชำระ และชำระตามสัดส่วนหลังประกาศผล โปรดระวังความเสี่ยง",
    priceJoule: "ราคา (JOULE)",
    investJoule: "ลงทุน (JOULE)",
    totalLiquidity: "สภาพคล่องรวม",
    dealPrice: "ราคาจับคู่",
    estProfit: "กำไรโดยประมาณ",
    jouleBalance: "ยอด JOULE: {n}",
    positionCount: "จำนวนโพซิชัน: {n}",
    max: "สูงสุด",
    confirmOrder: "ยืนยันคำสั่ง",
    ordering: "กำลังสั่ง...",
    enterAmount: "ใส่จำนวนลงทุน",
    invalidPrice: "ราคาไม่ถูกต้อง",
    amountExceed: "เกินยอดคงเหลือ",
    orderSuccess: "สั่งสำเร็จ",
    poolSize: "ขนาดพูล",
    colBalance: "ยอดคงเหลือ",
    shares: "{n} หน่วย",
    rulesTitle: "คำอธิบายกฎ",
    rulesValue: "ยังไม่มีคำอธิบาย",
    settleSource: "แหล่งชำระ",
    settleValue: "ยังไม่มีคำอธิบาย"
  },
  rank: {
    applyTitle: "Become an Expert",
    applyDesc: "Show your trading talent and earn revenue share",
    applyCta: "Join Now",
    tabExpert: "Expert Ranking",
    tabMaker: "Market Maker",
    tabWinRate: "Win Rate",
    tabProfit: "Profit",
    experts: {
      trendCatcher: "Trend Catcher",
      whaleWatcher: "Whale Watcher",
      cryptoWolf: "Crypto Wolf",
      swingCaptain: "Swing Captain",
      arbHunter: "Arb Hunter",
      bullKnight: "Bull Knight"
    },
    tagPolitics: "Politics",
    tagEsports: "Esports",
    comingSoon: "Coming soon"
  },
  operationManual: {
    title: "Operation Manual",
    docTitle: "PANTA MARKET Operation Manual",
    sourceHint: "Illustrated steps adapted from the official manual. Tap screenshots to zoom."
  },
  pantaMarket: {
    title: "Panta Market",
    tokenSection: "โทเคนกำกับดูแล PANTA",
    todayBurn: "เผาวันนี้",
    totalBurn: "เผาสะสม",
    burned: "เผาแล้ว",
    initialSupply: "อุปทานเริ่มต้น",
    maxSupply: "อุปทานสูงสุด",
    finalCirculation: "หมุนเวียนสุดท้าย",
    contractAddress: "สัญญา: ",
    copied: "คัดลอกแล้ว",
    ecoSection: "PANTA · ระบบนิเวศ AI",
    ecoTabs: {
      market: "วิเคราะห์ตลาด",
      arbitrage: "เครื่องมือเก็งกำไร",
      acquisition: "หาลูกค้าทั่วโลก",
      video: "สร้างวิดีโอ"
    },
    apps: {
      pantaAi: "Panta AI",
      asiStar: "ASI Star",
      tatianaTv: "Tatiana TV",
      tokenSpace: "Token space"
    },
    groupSection: "PANTA · กรุ๊ปครีเอทีฟ",
    groupTabs: {
      recommend: "แนะนำ",
      hot: "ฮิต",
      ipDrama: "IP ซีรีส์สั้น",
      ipCollab: "ร่วมสร้าง IP",
      data: "ข้อมูล"
    },
    filters: {
      all: "ทั้งหมด",
      new: "เปิดตัวใหม่",
      ending: "ใกล้จบ",
      highScore: "คะแนน AI สูง"
    },
    project: {
      badge: "เปิดตัวบน Planet",
      title: "《Panta AI · ผงาด》 อนิเมะสั้น AI",
      score: "คะแนน AI 92",
      tagDrama: "IP ซีรีส์สั้น",
      tagRights: "สิทธิ์ #0001",
      desc: "Panta AI พาพลิกสถานการณ์ — ซีรีส์สอนแอป AI"
    },
    values: {
      todayBurn: "321",
      totalBurn: "4,212",
      initialSupply: "10M",
      maxSupply: "210M",
      finalCirculation: "21M"
    }
  },
  copyTrade: {
    menuTitle: "คัดลอกเทรด",
    pageTitle: "คัดลอกเทรด",
    fallback: "การดำเนินการล้มเหลว โปรดลองอีกครั้งภายหลัง",
    pauseRule: "หากยังอยู่ในสถานะหยุดชั่วคราวเมื่อการชำระสัปดาห์นี้เสร็จสิ้น ความสัมพันธ์การคัดลอกจะถูกยกเลิกโดยอัตโนมัติในสัปดาห์หน้า",
    pauseSuccess: "หยุดชั่วคราวสำเร็จ",
    resumeSuccess: "ดำเนินการต่อแล้ว",
    endSuccess: "สิ้นสุดแล้ว",
    followSuccess: "เริ่มคัดลอกแล้ว",
    pendingReviewToast: "รอเทรดเดอร์ตรวจสอบ",
    savedSuccess: "บันทึกแล้ว",
    registerSuccess: "ลงทะเบียนแล้ว เงินประกันถูกแช่แข็ง",
    cancelRequested: "ส่งคำขอยกเลิกแล้ว",
    cancelWithdrawn: "ถอนคำขอยกเลิกแล้ว",
    kickedSuccess: "ลบออกแล้ว",
    approvedSuccess: "อนุมัติแล้ว",
    rejectedSuccess: "ปฏิเสธแล้ว",
    filledToForm: "กรอกลงแบบฟอร์มติดตามแล้ว",
    traderNotFound: {
      search: "ไม่พบเทรดเดอร์ ตรวจสอบที่อยู่กระเป๋าเงิน หรืออาจยังไม่ได้เปิดใช้คัดลอกเทรด",
      business: "เทรดเดอร์รายนี้ไม่พร้อมใช้งานในขณะนี้"
    },
    tabs: {
      board: "กระดานอันดับ",
      follows: "การติดตามของฉัน",
      join: "ติดตาม",
      trader: "นำเทรด",
      apps: "คำขอ",
      fans: "ผู้ติดตาม",
      rules: "กฎ",
      settings: "กฎ",
      follow: "ติดตาม"
    },
    ui: {
      refresh: "รีเฟรช",
      search: "ค้นหา",
      loginWallet: "เชื่อมต่อกระเป๋าเงิน",
      needLoginAction: "การดำเนินการนี้ต้องเข้าสู่ระบบกระเป๋าเงิน เหมือนการสั่งซื้อ",
      needLoginTrader: "API เทรดเดอร์ต้องเข้าสู่ระบบ",
      loginToView: "เข้าสู่ระบบเพื่อดู",
      loading: "กำลังโหลด…",
      empty: "ไม่มี",
      readonly: "อ่านอย่างเดียว",
      yes: "ใช่",
      no: "ไม่",
      immediate: "มีผลทันที",
      current: "ปัจจุบัน",
      nextWeek: "สัปดาห์หน้า",
      pause: "หยุดชั่วคราว",
      resume: "ดำเนินการต่อ",
      end: "สิ้นสุด",
      save: "บันทึก",
      kick: "ลบออก",
      approve: "อนุมัติ",
      reject: "ปฏิเสธ",
      requestCancel: "ขอยกเลิก",
      withdrawCancel: "ถอนคำขอยกเลิก",
      confirmFollow: "ยืนยันการติดตาม",
      registerWithDeposit: "แช่แข็งเงินประกันและลงทะเบียน",
      registerConfirmTitle: "ยืนยันการลงทะเบียน",
      registerFreezeConfirm: "บัญชีเทรดจะอายัดมาร์จิ้น {amount} JOULE",
      platformSettings: "การตั้งค่าแพลตฟอร์ม",
      settingsTip: "คัดลอกเฉพาะคำสั่งนำเทรดแบบปกติที่มีประกัน คำสั่งปกติไม่มีประกันและคำสั่ง AI จะไม่ถูกคัดลอก และคำสั่ง COPY ที่สร้างจะไม่นำเทรดต่อ เทรดเดอร์ใช้ API คำสั่งที่มีอยู่และไม่ควรส่ง orderSource ผู้ติดตามเห็นคำสั่ง COPY ในรายการ จำนวนเงินแสดงทศนิยม 2 ตำแหน่ง ส่วนเกินตัดทิ้ง",
      deposit: "เงินประกัน",
      depositFreezeWeeks: "สัปดาห์แช่แข็งเงินประกัน",
      maxFollowers: "จำกัดผู้ติดตาม",
      shareRateRange: "ช่วงอัตราแบ่งปัน",
      shareRateDefault: "อัตราแบ่งปันเริ่มต้น",
      shareRateNextWeek: "อัตราแบ่งปันมีผลสัปดาห์หน้า",
      pendingShareHint: "มีผลวันจันทร์หน้า: {rate}",
      pendingMaxFollowersHint: "มีผลวันจันทร์หน้า: {n}",
      depositFrozenShort: "ยังแช่แข็ง",
      minFollowStake: "เงินติดตามขั้นต่ำ",
      ratioRange: "ช่วงอัตราส่วน",
      maxSimultaneousFollows: "ติดตามพร้อมกันสูงสุด",
      defaultReview: "การตรวจสอบเริ่มต้น",
      defaultMinBalance: "เกณฑ์ยอดคงเหลือเริ่มต้น",
      settlementTimezone: "เขตเวลาการชำระ",
      leaderboardMeta: "ขั้นต่ำกระดาน / จำนวน",
      leaderboardMetaValue: "{min} คำสั่ง / {size} แถว",
      weekLeaderboard: "กระดานอัตราชนะสัปดาห์นี้",
      expertLeaderboard: "กระดานเทรดเดอร์",
      heroTitle: "เป็นเทรดเดอร์นำ",
      heroDesc: "เริ่มนำเทรดและรับส่วนแบ่งกำไร",
      heroActiveTitle: "คุณเป็นเทรดเดอร์นำแล้ว",
      heroActiveDesc: "สถานะเทรดเดอร์นำของคุณใช้งานอยู่",
      heroRegister: "ลงทะเบียน",
      heroSettings: "ตั้งค่านำเทรด",
      myLeading: "การนำเทรดของฉัน",
      winRateBoard: "อัตราชนะ",
      pnlBoard: "กำไร",
      searchAddress: "ค้นหาที่อยู่",
      searchNicknameOrAddress: "ค้นหาชื่อหรือที่อยู่",
      searchQueryTooShort: "กรอกอย่างน้อย 2 ตัวอักษร",
      winRateShort: "อัตราชนะ",
      followersLabel: "ผู้ติดตาม:",
      shareRateLabel: "อัตราแบ่งปัน:",
      roundPnlLabel: "กำไรขาดทุนรอบ:",
      settledOrders: "ชำระแล้ว {n}",
      activeCount: "กำลังดำเนินการ",
      followStatsShort: "พูล {pool} · ค้าง {cash}",
      traderSettings: "ตั้งค่านำเทรด",
      confirmChanges: "ยืนยันการเปลี่ยนแปลง",
      confirmCancel: "ยืนยันการยกเลิก",
      cancelModalTitle: "แจ้งการยกเลิก",
      activeInProgress: "กำลังดำเนินการ",
      leadingFollowerCount: "ผู้ติดตาม {n}",
      auditApps: "คำขอ {n}",
      leaderboardNote: "นับเฉพาะคำสั่งปกติมีประกันที่ชนะ/แพ้และชำระแล้วของสัปดาห์นี้ หลังจำนวนคำสั่งขั้นต่ำ ไม่ใช่อัตราชนะตลอดกาลหรือ AI ไม่มีชื่อทีมและปริมาณติดตามสะสม",
      weekStart: "เริ่มสัปดาห์ (จ.): {date}",
      leaderboardEmpty: "ยังไม่มีเทรดเดอร์ในกระดาน ค้นหาที่อยู่เต็มเพื่อติดตาม",
      winRate: "ชนะ {n}%",
      boardSub: "แบ่งปัน {share} · ผู้ติดตาม {followers}/{max} · ชำระ {orders} · กำไรขาดทุนสัปดาห์ {pnl} JOULE",
      searchTrader: "ค้นหาเทรดเดอร์",
      walletPlaceholder: "ที่อยู่กระเป๋าเงินเต็ม 0x…",
      address: "ที่อยู่",
      status: "สถานะ",
      shareRate: "อัตราแบ่งปัน",
      review: "ตรวจสอบ",
      minBalance: "เกณฑ์ยอดคงเหลือ",
      followerCount: "ผู้ติดตาม",
      startFollow: "เริ่มติดตาม",
      traderWallet: "ที่อยู่เทรดเดอร์",
      followMode: "โหมดติดตาม",
      ratioLabel: "อัตราส่วน (%) ช่วง {min} ~ {max}",
      insuranceMode: "โหมดประกัน",
      takeProfit: "ทำกำไร (JOULE, ไม่บังคับ)",
      stopLoss: "ตัดขาดทุน (JOULE, ไม่บังคับ)",
      takeProfitPh: "หยุดชั่วคราวเมื่อกำไรสุทธิรายสัปดาห์ถึงค่านี้",
      stopLossPh: "หยุดชั่วคราวเมื่อขาดทุนสุทธิรายสัปดาห์ถึงค่านี้",
      followHint: "ติดตามได้สูงสุด {n} เทรดเดอร์พร้อมกัน เมื่อถึงขีดจำกัด การติดตามใหม่จะสิ้นสุดความสัมพันธ์เดิมก่อน — ไม่ใช่ตัวอย่างที่ไม่มีผล หากต้องการเปลี่ยนพารามิเตอร์ ให้สิ้นสุดแล้วติดตามใหม่",
      endConfirm:
        "ยืนยันสิ้นสุดความสัมพันธ์คัดลอกกับเทรดเดอร์รายนี้? หลังสิ้นสุดจะไม่ติดตามสัญญาณอีก คำสั่งในอดีตและ PnL ที่ชำระแล้วไม่ได้รับผลกระทบ",
      weeklyPoolHint: "พูลเป็นของสัปดาห์นี้ ไม่ใช่ปริมาณติดตามสะสม ความสัมพันธ์ที่สิ้นสุดและคำขอรอตรวจไม่อยู่ในรายการนี้",
      networkUnclear: "ยังไม่ยืนยันผลลัพธ์ โปรดรีเฟรชและตรวจสอบความสัมพันธ์หรือโปรไฟล์เทรดเดอร์ก่อนลองใหม่",
      myFollows: "การติดตามของฉัน",
      noFollows: "ไม่มีความสัมพันธ์การติดตาม",
      followSub: "{mode}{ratio} · {insurance} · แบ่งปันล็อก {share}",
      followStats: "กำไรขาดทุนสัปดาห์ {pnl} · พูล {pool} · ค้าง {cash}",
      pauseReason: "เหตุผลหยุดชั่วคราว: {reason}",
      registerTrader: "ลงทะเบียนเป็นเทรดเดอร์",
      registerHint: "ลงทะเบียน: ชำระ {amount} JOULE เป็นเงินประกันเทรดเดอร์นำ (แช่แข็งขณะใช้งาน คืนหลังตรวจยกเลิก) หนึ่งกระเป๋าเงินต่อหนึ่งตัวตนเทรดเดอร์",
      registerBalanceHint: "หลังแช่แข็งเงินประกัน {deposit} JOULE ยอดคงเหลือที่ใช้ได้ต้อง ≥ {remain} JOULE",
      shareRateInput: "อัตราแบ่งปัน (%) ช่วง {min} ~ {max} การเปลี่ยนแปลงมีผลรอบถัดไป",
      maxFollowersInput: "จำกัดผู้ติดตาม (≤ {max})",
      reviewMode: "วิธีอนุมัติ",
      minBalanceInput: "เกณฑ์ยอดคงเหลือผู้ติดตาม · ไม่บังคับ (JOULE)",
      myTrader: "โปรไฟล์เทรดเดอร์ของฉัน",
      depositHeld: "{amount} / แช่แข็ง {held}",
      currentFollowers: "ผู้ติดตามปัจจุบัน",
      cancelEffective: "ยกเลิกมีผลเมื่อ",
      depositRelease: "คืนเงินประกันเมื่อ",
      editParams: "แก้ไขการตั้งค่า",
      editHint: "แบ่งปัน/จำกัดมีผลสัปดาห์หน้า การตรวจสอบและเกณฑ์มีผลทันที ช่วงล็อกการชำระ อา. 22:00 ถึงก่อน จ. 01:00 (SGT) อิงเซิร์ฟเวอร์ อย่ากลับมาแก้เองตอน จ. 00:00",
      shareRatePercent: "อัตราแบ่งปัน (%)",
      minBalanceJoule: "เกณฑ์ยอดคงเหลือ (JOULE)",
      cancelTip: "หลังยกเลิกยังนำเทรดสัปดาห์นี้ ตัวตนสิ้นสุดจันทร์หน้า 00:00 เงินประกันแช่แข็งอีกหนึ่งสัปดาห์แล้วคืน ถอนได้ก่อนมีผล",
      followers: "ผู้ติดตาม",
      followerSub: "{mode}{ratio} · กำไรขาดทุนสัปดาห์ {pnl} · ค้าง {cash}",
      applications: "คำขอรอดำเนินการ",
      noApplications: "ไม่มีคำขอ",
      fillForm: "กรอกแบบฟอร์มติดตาม",
      needTraderFirst: "ลงทะเบียนเป็นเทรดเดอร์ก่อน",
      cancelRequestedAt: "ขอยกเลิกเมื่อ",
      ratioRangeInvalid: "อัตราส่วนต้องอยู่ระหว่าง {min} ถึง {max}",
      shareRangeInvalid: "อัตราแบ่งปันต้องอยู่ระหว่าง {min} ถึง {max}",
      maxFollowersInvalid: "จำกัดผู้ติดตามต้องไม่เกิน {max}",
      needShareRate: "กรอกอัตราแบ่งปัน",
      needMaxFollowers: "กรอกจำกัดผู้ติดตาม",
      needRatio: "กรอกอัตราส่วน",
      badTakeProfit: "จำนวนทำกำไรไม่ถูกต้อง",
      badStopLoss: "จำนวนตัดขาดทุนไม่ถูกต้อง",
      badMinBalance: "เกณฑ์ยอดคงเหลือไม่ถูกต้อง",
      insuranceShortFollow: "ตาม",
      insuranceShortOn: "เปิดเสมอ",
      insuranceShortOff: "ปิดเสมอ",
      symbolSettings: "ตั้งค่าสัญลักษณ์คัดลอก",
      symbolPickHint: "ปิดทั้งหมดเริ่มต้น เปิดเอง แก้ไขได้ทุกเมื่อ",
      followSymbolHint: "เลือกจากสัญลักษณ์ที่เทรดเดอร์อนุญาต เปิดอย่างน้อยหนึ่งรายการ",
      followSymbolWait: "ค้นหาเทรดเดอร์ก่อน แล้วเลือกสัญลักษณ์ที่จะติดตาม",
      symbolNeedOne: "เปิดอย่างน้อยหนึ่งสัญลักษณ์",
      symbolNotAllowed: "สัญลักษณ์ที่เลือกไม่ได้รับอนุญาตจากเทรดเดอร์รายนี้",
      effectiveSymbols: "มีผล",
      editSymbols: "แก้ไขสัญลักษณ์",
      allowedSymbols: "สัญลักษณ์ที่เปิด",
      weekPnlLabel: "กำไรขาดทุนสัปดาห์:",
      currentNetPnlLabel: "Current Net PnL",
      categoryCrypto: "คริปโต",
      categoryCommodity: "สินค้าโภคภัณฑ์",
      categoryEquity: "หุ้น",
      symbolListCol: "รายการ",
      symbolLeadCol: "นำ",
      symbolFollowCol: "ติดตาม",
      symbolTags: "เปิด",
      leadingSymbols: "สัญลักษณ์นำเทรด",
      detail: "รายละเอียด",
      enabled: "เปิด",
      disabled: "ปิด",
      held: "ถืออยู่",
      notHeld: "ไม่ถือ",
      weekSettledOrders: "ชำระสัปดาห์นี้",
      historicalNetPnl: "กำไรขาดทุนสะสม",
      copyTotalPnl: "กำไรขาดทุนรวมการคัดลอก",
      historicalSharePayout: "การจ่ายแบ่งปัน",
      allOrders: "ทั้งหมด",
      prevPage: "Prev",
      nextPage: "Next",
      pageOf: "{page} / {totalPages}",
      jumpToPage: "Go to",
      jumpConfirm: "Go",
      openOrders: "เปิดอยู่",
      settledOrdersTab: "ชำระแล้ว",
      colInterval: "ระยะเวลา",
      colOrderTime: "เวลาสั่ง",
      colSelfPnl: "กำไรขาดทุนตนเอง (รวมเบี้ย)",
      colEstShare: "แบ่งปันโดยประมาณ (JOULE)",
      traderOrdersTitle: "คำสั่งนำ {symbol}",
      followOrdersTitle: "คำสั่งคัดลอก {symbol}",
      selfPnl: "กำไรขาดทุนตนเอง",
      estimatedShare: "แบ่งปันโดยประมาณ",
      inProgress: "กำลังดำเนินการ",
      followAssets: "กำไรขาดทุนตามสินทรัพย์",
      byAsset: "ตามสินทรัพย์",
      followHistory: "สิ้นสุดแล้ว",
      followStartTime: "เริ่ม: ",
      followEndTime: "สิ้นสุด: ",
      myPendingApps: "รอดำเนินการ",
      cashHeldHint: "แบ่งปันโดยประมาณค้างสัปดาห์นี้ {cash} JOULE",
      cashHeldFrozen: "หักแบ่งปันโดยประมาณรอบนี้: {cash} (JOULE, แช่แข็ง)",
      followedTrader: "เทรดเดอร์",
      followInfo: "ข้อมูลติดตาม",
      totalPnlJoule: "กำไรขาดทุนรวม (JOULE)",
      colTrader: "เทรดเดอร์",
      colPrincipal: "เงินต้น",
      colPnlShare: "กำไรขาดทุน (รวมเบี้ย) / แบ่งปัน (JOULE)",
      traderInfo: "โปรไฟล์เทรดเดอร์",
      traderNotFound: "ไม่พบเทรดเดอร์",
      followSettingsRelationHint: "โหมดตาม อินชัวรันซ์ และ TP/SL ใช้กับทั้งความสัมพันธ์และทุกสัญลักษณ์ที่เลือก สามารถแก้ได้ตลอดในตั้งค่าตามออเดอร์",
      followSettingsPrepareHint: "ยืนยันแล้วจะใช้การตั้งค่าชุดเดียวกันกับทุกสัญลักษณ์ที่เลือก",
      followOptions: "ตัวเลือกติดตาม",
      noFollowOptions: "ไม่มีตัวเลือกติดตาม~",
      symbolFollowing: "กำลังติดตาม",
      symbolPaused: "หยุดชั่วคราว",
      symbolIdle: "ไม่ได้ติดตาม",
      cancelFollowSymbol: "เลิกติดตาม",
      cancelSymbolConfirm: "เลิกติดตาม {symbol}?",
      cancelLastSymbolConfirm: "นี่คือสัญลักษณ์สุดท้าย การเลิกติดตามจะสิ้นสุดความสัมพันธ์ทั้งหมด ดำเนินการต่อ?",
      followNow: "ติดตามทันที",
      followAll: "ติดตาม",
      unfollowAll: "เลิกติดตาม",
      unfollowAllConfirm: "เลิกติดตามสัญลักษณ์ทั้งหมดจากเทรดเดอร์รายนี้? จะสิ้นสุดความสัมพันธ์คัดลอกทั้งหมด",
      followSettings: "ตั้งค่าการติดตาม",
      goFollowSettings: "ไป ›",
      copyAccountBalance: "บัญชีคัดลอก: {amount} JOULE",
      orderFollowerCount: "จำนวนผู้ติดตามออเดอร์นี้",
      copyingStatus: "กำลังคัดลอก",
      roleStatusLeading: "กำลังนำเทรด",
      roleStatusFollowing: "กำลังตามเทรด",
      roleStatusPaused: "ตามเทรดถูกหยุด",
      copyOrderTag: "คัดลอก",
      copyOpenPositions: "สถานะคัดลอกที่เปิดอยู่",
      copyInsuredOrdinary: "มีประกันทั่วไป",
      copyUninsured: "ไม่มีประกัน",
      addSymbolHint: "สัญลักษณ์นี้จะถูกเพิ่มในการติดตามปัจจุบันของคุณ",
      myRelationStatus: "การติดตามของฉัน",
      latestSettlements: "การชำระล่าสุด",
      resumeRelationFirst: "ความสัมพันธ์หยุดทั้งหมด โปรดดำเนินการต่อในการติดตามของฉันก่อนดำเนินการตามสัญลักษณ์",
      resumeStopLossHint: "Current weekly loss is {amount}. Set stop-loss above {amount} to resume copying.",
      resumeTakeProfitHint: "Current weekly profit is {amount}. Set take-profit above {amount} to resume copying.",
      resumeStartFollow: "Start following",
      colType: "ประเภท",
      colPnlJoule: "กำไรขาดทุน (JOULE)",
      tpSl: "ทำกำไร / ตัดขาดทุน",
      takeProfitPhFull: "หยุดชั่วคราวหลังกำไรสุทธิรายสัปดาห์ — ไม่บังคับ (JOULE)",
      stopLossPhFull: "หยุดชั่วคราวหลังขาดทุนสุทธิรายสัปดาห์ — ไม่บังคับ (JOULE)",
      confirmModify: "ยืนยัน",
      clearSearch: "กลับไปกระดาน",
      searchResultHint: "ผลการค้นหา (แตะเพื่อเปิดโปรไฟล์เทรดเดอร์)",
      searchEmpty: "ไม่พบเทรดเดอร์",
      noMoreSettlements: "ไม่มีเพิ่มเติม"
    },
    errors: {
      AUTH_REQUIRED: "โปรดเชื่อมต่อกระเป๋าเงินก่อน",
      AUTH_UNAVAILABLE: "บริการเข้าสู่ระบบไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้งภายหลัง",
      POSTGRES_REQUIRED: "บริการไม่พร้อมใช้งานชั่วคราว โปรดลองอีกครั้งภายหลัง",
      USER_NOT_FOUND: "ไม่พบผู้ใช้ โปรดเข้าสู่ระบบใหม่แล้วลองอีกครั้ง",
      INVALID_WALLET: "กรอกที่อยู่กระเป๋าเงินให้ครบ",
      INVALID_QUERY: "คำค้นไม่ถูกต้อง กรอกอย่างน้อย 2 ตัวอักษร",
      INVALID_AMOUNT: "รูปแบบจำนวนเงินไม่ถูกต้อง",
      INVALID_PARAM: "พารามิเตอร์ไม่ถูกต้อง โปรดตรวจสอบแล้วลองใหม่",
      INVALID_FOLLOW: "ไม่สามารถคัดลอกการเทรดของตนเอง",
      TRADER_EXISTS: "กระเป๋าเงินนี้เป็นเทรดเดอร์แล้ว ไม่ต้องลงทะเบียนซ้ำ",
      TRADER_FULL: "เทรดเดอร์รายนี้ถึงจำกัดผู้ติดตามแล้ว",
      TRADER_CANCELLED: "บัญชีเทรดเดอร์นี้ถูกยกเลิกแล้ว",
      TRADER_REGISTER_FAILED: "ลงทะเบียนเทรดเดอร์ล้มเหลว โปรดลองอีกครั้งภายหลัง",
      TRADER_SETTINGS_FAILED: "บันทึกการตั้งค่าเทรดเดอร์ล้มเหลว โปรดลองอีกครั้งภายหลัง",
      NOT_A_TRADER: "Register as a trader first",
      TRADER_UNAVAILABLE: "This trader is currently unavailable",
      INSUFFICIENT_BALANCE: "ยอดคงเหลือไม่เพียงพอสำหรับแช่แข็งเงินประกัน",
      BALANCE_TOO_LOW: "ยอดบัญชีคัดลอกต่ำกว่าเกณฑ์เทรดเดอร์นี้ กรุณาโอนจากบัญชีเทรดก่อน",
      COPY_BALANCE_ZERO: "ยอดบัญชีคัดลอกเป็น 0 กรุณาโอนจากบัญชีเทรดก่อน",
      INSUFFICIENT_FUNDS: "ยอดบัญชีเทรดไม่พอสำหรับโอนเข้าบัญชีคัดลอก",
      COPY_TRADE_BALANCE_INSUFFICIENT: "ยอดใช้ได้ในบัญชีคัดลอกไม่พอ (เงินแช่แข็ง/ส่วนแบ่งถอนไม่ได้)",
      ACCOUNT_NOT_FOUND: "ข้อผิดพลาดบัญชี โปรดลองอีกครั้งภายหลัง",
      ACCOUNT_CONFLICT: "บัญชีกำลังอัปเดต โปรดลองอีกครั้งภายหลัง",
      FOLLOW_EXISTS: "คุณติดตามเทรดเดอร์รายนี้อยู่แล้ว",
      FOLLOW_LIMIT: "คุณมีความสัมพันธ์คัดลอกที่ใช้งานอยู่ โปรดสิ้นสุดก่อนติดตามเทรดเดอร์อื่น",
      FOLLOW_FAILED: "เริ่มคัดลอกล้มเหลว โปรดลองอีกครั้งภายหลัง",
      FOLLOW_NOT_FOUND: "ไม่พบความสัมพันธ์คัดลอก",
      PAUSE_FAILED: "หยุดคัดลอกชั่วคราวล้มเหลว โปรดลองอีกครั้งภายหลัง",
      RESUME_FAILED: "ดำเนินการคัดลอกต่อล้มเหลว โปรดลองอีกครั้งภายหลัง",
      STOP_LOSS_THRESHOLD: "Stop-loss is still too low. Raise or clear it, then resume.",
      TAKE_PROFIT_THRESHOLD: "Take-profit is still too low. Raise or clear it, then resume.",
      END_FAILED: "สิ้นสุดคัดลอกล้มเหลว โปรดลองอีกครั้งภายหลัง",
      APPLICATION_NOT_FOUND: "ไม่พบคำขอรอดำเนินการ",
      APPROVE_FAILED: "อนุมัติคำขอล้มเหลว โปรดลองอีกครั้งภายหลัง",
      REJECT_FAILED: "ปฏิเสธคำขอล้มเหลว โปรดลองอีกครั้งภายหลัง",
      KICK_FAILED: "ลบผู้ติดตามล้มเหลว โปรดลองอีกครั้งภายหลัง",
      SETTLEMENT_WINDOW: "ไม่สามารถเปลี่ยนการตั้งค่าเทรดเดอร์ในช่วงการชำระ",
      CANCEL_FAILED: "ขอยกเลิกล้มเหลว โปรดลองอีกครั้งภายหลัง",
      CANCEL_NOT_PENDING: "ไม่มีคำขอยกเลิกที่จะถอน",
      CANCEL_WITHDRAW_FAILED: "ถอนคำขอยกเลิกล้มเหลว โปรดลองอีกครั้งภายหลัง",
      COPY_SETTINGS_MISSING: "การตั้งค่าคัดลอกเทรดยังไม่พร้อม โปรดลองอีกครั้งภายหลัง",
      INVALID_SYMBOL: "เลือกสัญลักษณ์ที่รองรับอย่างน้อยหนึ่งรายการ",
      SYMBOL_NOT_ALLOWED: "มีสัญลักษณ์ที่เทรดเดอร์รายนี้ไม่อนุญาต",
      TRADER_BALANCE_TOO_LOW: "ยอดคงเหลือหลังแช่แข็งเงินประกันต่ำเกินไปสำหรับลงทะเบียน",
      TIMEOUT: "การดำเนินการล้มเหลว โปรดลองอีกครั้งภายหลัง",
      NETWORK: "การดำเนินการล้มเหลว โปรดลองอีกครั้งภายหลัง"
    },
    status: {
      ACTIVE: "ใช้งาน",
      PAUSED: "หยุดชั่วคราว",
      ENDED: "สิ้นสุด",
      PENDING_REVIEW: "รอเทรดเดอร์ตรวจสอบ",
      CANCEL_PENDING: "รอยกเลิก",
      CANCELLED: "ยกเลิกแล้ว"
    },
    traderStatus: {
      ACTIVE: "กำลังนำ",
      CANCEL_PENDING: "กำลังออก",
      CANCELLED: "ยกเลิกแล้ว",
    },
    pauseReason: {
      USER: "ผู้ใช้หยุดชั่วคราว",
      INSUFFICIENT_BALANCE: "บัญชีคัดลอกยอดไม่พอ จึงหยุดชั่วคราว",
      TAKE_PROFIT: "ทำกำไรทริกเกอร์",
      STOP_LOSS: "ตัดขาดทุนทริกเกอร์",
      TRADER_KICK: "ถูกลบโดยเทรดเดอร์",
      SWITCH: "เปลี่ยนเทรดเดอร์",
      SETTLEMENT_CLEANUP: "ถูกลบเมื่อชำระรายสัปดาห์",
      TRADER_CANCEL: "เทรดเดอร์ยกเลิก"
    },
    followMode: {
      EQUAL: "จำนวนเท่ากัน",
      RATIO: "อัตราส่วน"
    },
    insuranceMode: {
      FOLLOW: "ตามเทรดเดอร์",
      ALWAYS_ON: "เปิดเสมอ",
      ALWAYS_OFF: "ปิดเสมอ"
    },
    reviewMode: {
      AUTO: "ติดตามอัตโนมัติ",
      MANUAL: "ติดตามต้องตรวจสอบ"
    },
    applicationStatus: {
      PENDING: "รอดำเนินการ",
      APPROVED: "อนุมัติแล้ว",
      REJECTED: "ปฏิเสธแล้ว",
      CANCELLED: "ยกเลิกแล้ว",
      PENDING_REVIEW: "รอดำเนินการ"
    }
  },}
